"use strict";

// tweaks these below variable if you want to show subtotal and discount
var showCartSubTotalDiscountSection = false;
var showEmptyCartIcon = false;
var showCartCountInTopNav = true;
var showProgressBar = true;
var showVendorOnCartPage = false;
var enablePlusQuantity = false;
var disablePlusQuantityAfterNumber = 6;
var removeMiniCartTextOrIcon = '<svg width="12" height="10" viewBox="0 0 12 10" xmlns="http://www.w3.org/2000/svg"><path d="m1.05.05 9.9 9.9m0-9.9-9.9 9.9" stroke="#2E3330" fill="none" fill-rule="evenodd"/></svg>';
var plusIcon = '  <svg width="10" height="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"> <g stroke="#272F33" fill="none" fill-rule="evenodd"><path d="M5 0v10M10 5H0"/> </g></svg>';
var minusIcon = '<svg width="10" height="1" viewBox="0 0 10 1" xmlns="http://www.w3.org/2000/svg"><path d="M10 .5H0" stroke="#272F33" fill="none" fill-rule="evenodd"/></svg>'; // Fixed variables

var lineItemComparePrice;
var cartObject;
var cartCountEmptyValue = "0";
var boxID = "_Box ID"; //extra classes for the elements

var removeExtraClass = "btn-border-black-animate";
/* CUSTOM OFFERS */
//black friday main productID

var promoOfferQuantity = 0;
var boolPromoOffer_BlackFriday_ProductID = false; //Replace on LIVE

var promoOffer_BlackFriday_ProductID = "6737920098374";
var promoOffer_BlackFriday_FreeBag_ProductID = "6737924587590"; // recharge 2020

var frequency = "";
var recurringchecked = false;
var frequency_unit = "";

$(document).ready(function ($) {
  reloadAjaxCartItemUsingCartAjaxObject();
  progressBar();
  quickCartTotal();
  calculateSubTotalWithDiscount();
  /*cart numeric type*/

  $(".js__cart__quantity-selector").keypress(function (event) {
    var keycode = event.keyCode || event.which;

    if (keycode == "13") {
      event.preventDefault();

      if ($(this).val() == "0") {
        $(this).val("1");
      }

      var lineCount = $(this).attr("data-cart-line-count");
      updateQuantity(lineCount);
      return false;
    }
  });
});

$(document).ready(function ($) {
  
  /*Custom cart contribution working*/
    
  $("body").on("keyup", "#js__text-cart-contribution", processContribution )
  $("body").on("click", "#contribution-add-btn", processContribution )
    
    
    
  function processContribution(e){
    /*On Keyup checking enter keypress or not */    
    if (e.keyCode === 13 || e.type == 'click' ) {
      e.preventDefault();
      /*empty check of textbox */

      if ($("#js__text-cart-contribution").val() != "") {
        var cVal = parseInt($("#js__text-cart-contribution").val());
        console.log("cVal" + cVal);
        /*if value greater than 0 then adding item in cart if item already there then updated with new quantity */

        if (cVal > 0) {
          var count = 1;
          var boolCItem = false;
          $(cartObject.items).each(function () {
            var id = this.id;
            console.log("cartObject" + id);

            if (id == "40826253279343") {
              boolCItem = true;
              CartJS.updateItem(count, cVal, {}, {
                success: function success(data, textStatus, jqXHR) {
                  $("#js__text-cart-contribution").val(''); //console.log(data);
                  // //Rebind the line item price
                  // reloadAjaxCartItemUsingCartAjaxObject(data);
                },
                error: function error(jqXHR, textStatus, errorThrown) {//console.log("Error: " + errorThrown + "!");
                },
                complete: function complete(jqXHR, textStatus, errorThrown) {//console.log(jqXHR);
                  //console.log(textStatus);
                  //console.log(errorThrown);
                }
              });
            }

            count++;
          });

          if (boolCItem == false) {
            var items = [];
            /* For the main item */

            items.push({
              id: "40826253279343",
              quantity: cVal
            });
            CartJS.addItems(items, {
              success: function success(response, textStatus, jqXHR) {},
              // Define an error callback to display an error message.
              error: function error(jqXHR, textStatus, errorThrown) {}
            });
          }
        }
      }
    }
  }
    
});
/*
EVENTS
1. Update quantity
2. minus quantity
3. plus quantity
4. remove item from cart
5. reload ajax cart
6. quickCartTotal
7. calculateSubTotalWithDiscount
8. cart.requestComplete
*/
//QUANTITY UPDATE

function updateQuantity(cartThis) {
  var lineItemCount = cartThis;
  lineItemCount = parseInt(lineItemCount);
  var itemPrice = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__raw-line-item-price").text();
  itemPrice = itemPrice.replace(/[^0-9]/gi, "");
  itemPrice = parseInt(itemPrice);
  var lineItemComparePrice = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__raw-item-compare-price").text().replace(/[^0-9]/gi, "");
  lineItemComparePrice = parseInt(lineItemComparePrice);
  var variantID = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').attr("data-variant-id");
  variantID = parseInt(variantID);
  var newQuantity = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find("input[name='updates[]']").val();
  newQuantity = parseInt(newQuantity);
  /* NOTE: you will not get Raw Inventory against the variant in API calls */

  /* PENDING, need to find a solution for this */

  /* Need to check stock levels for the variant 
  as cartJS is giving success even if the stock levels are low and not going into Error*/

  var rawStockVariantQuantity = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find("input[name='updates[]']").attr("data-attr-raw-variant-quantity");
  /* If the new quantity is less then the stock then update the item */

  rawStockVariantQuantity = isNaN(rawStockVariantQuantity) ? "10000" : rawStockVariantQuantity;
  rawStockVariantQuantity = parseInt(rawStockVariantQuantity);

  if (newQuantity < rawStockVariantQuantity) {
    $("input[name='updates[]']").filter('[data-cart-line-count="' + lineItemCount + '"]').val(newQuantity);
    /* Update the item */

    CartJS.updateItem(lineItemCount, newQuantity, {}, {
      success: function success(data, textStatus, jqXHR) {//console.log(data);
        // //Rebind the line item price
        // reloadAjaxCartItemUsingCartAjaxObject(data);
      },
      error: function error(jqXHR, textStatus, errorThrown) {//console.log("Error: " + errorThrown + "!");
      },
      complete: function complete(jqXHR, textStatus, errorThrown) {//console.log(jqXHR);
        //console.log(textStatus);
        //console.log(errorThrown);
      }
    });
  } else {
    /* Show a message out of stock */
    $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__out-of-stock").html("Out of stock");
    $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__out-of-stock").show();
    $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__out-of-stock").delay(2000).fadeOut();
  }
}

function minusQuantity(cartThis) {
  // debugger;
  var lineItemCount = cartThis;
  lineItemCount = parseInt(lineItemCount);
  var itemPrice = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__raw-line-item-price").text();
  itemPrice = itemPrice.replace(/[^0-9]/gi, "");
  itemPrice = parseInt(itemPrice);
  var lineItemComparePrice = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__raw-item-compare-price").text().replace(/[^0-9]/gi, "");
  lineItemComparePrice = parseInt(lineItemComparePrice);
  var variantID = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').attr("data-variant-id");
  variantID = parseInt(variantID);
  var newQuantity = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find("input[name='updates[]']").val();
  newQuantity = parseInt(newQuantity);
  newQuantity = newQuantity - 1;
  $("input[name='updates[]']").filter('[data-cart-line-count="' + lineItemCount + '"]').val(newQuantity); // CUSTOM - Loop through properties to check if there is a product with PromoOffer, if yes, then set the bool to true

  var properties = loopThroughCartItems_on_VariantID(variantID);

  if (properties != null) {
    if (Object.keys(properties).length > 0) {
      $.each(properties, function (key, value) {
        if (key == "_promoOffer") {
          boolPromoOffer_BlackFriday_ProductID = true;
        }
      });
    }
  }

  if (newQuantity < 1) {
    removeItem(lineItemCount);
  } else {
    CartJS.updateItem(lineItemCount, newQuantity, {}, {
      success: function success(data, textStatus, jqXHR) {},
      error: function error(jqXHR, textStatus, errorThrown) {//console.log("Error: " + errorThrown + "!");
      }
    });
    /*
    if you want to update item by ID and not by line item then you can use updateItemId function
    Recommended - line item update
    CartJS.updateItemById(lineIndex, newQuantity);
    */
  } // CUSTOM -
  //if the promo main product exists and it's quantity is less then 2, then remove the promo free bag product
  // if promo main product quantity  = 1; then remove the free bag and update the promo main product quantity
  // if promo main product quantity  = 0; then remove the promo main product
  // update the quantity for the promo main product


  if (boolPromoOffer_BlackFriday_ProductID && newQuantity <= 1) {
    if (newQuantity == 1) {
      //console.log("BLACK FRIDAY: Quantity 1");
      //loop through the cart items to get the variant ID for the PROMO - Free bag product
      //console.log("BLACK FRIDAY: going to delete free bag ");
      var _variantID = loopThroughCartItems_on_ProductID(promoOffer_BlackFriday_FreeBag_ProductID);

      removeItemById(_variantID);
    }
  }
}

function plusQuantity(cartThis) {
  var lineItemCount = cartThis;
  lineItemCount = parseInt(lineItemCount);
  var itemPrice = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__raw-line-item-price").text();
  itemPrice = itemPrice.replace(/[^0-9]/gi, "");
  itemPrice = parseInt(itemPrice);
  var lineItemComparePrice = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__raw-item-compare-price").text().replace(/[^0-9]/gi, "");
  lineItemComparePrice = parseInt(lineItemComparePrice);
  var variantID = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').attr("data-variant-id");
  variantID = parseInt(variantID);
  var newQuantity = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find("input[name='updates[]']").val();
  newQuantity = parseInt(newQuantity); // Disable the PLUS quantity feature

  var proceedToUpdateQuantity = false;

  if (enablePlusQuantity) {
    if (newQuantity > disablePlusQuantityAfterNumber) {
      proceedToUpdateQuantity = true;
    }
  }

  if (proceedToUpdateQuantity == false) {
    newQuantity = newQuantity + 1;
    /* NOTE: you will not get Raw Inventory against the variant in API calls */

    /* PENDING, need to find a solution for this */

    /* Need to check stock levels for the variant 
    as cartJS is giving success even if the stock levels are low and not going into Error*/

    var rawStockVariantQuantity = $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find("input[name='updates[]']").attr("data-attr-raw-variant-quantity");
    /* If the new quantity is less then the stock then update the item */

    rawStockVariantQuantity = isNaN(rawStockVariantQuantity) ? "10000" : rawStockVariantQuantity;
    rawStockVariantQuantity = parseInt(rawStockVariantQuantity);

    if (newQuantity < rawStockVariantQuantity) {
      $("input[name='updates[]']").filter('[data-cart-line-count="' + lineItemCount + '"]').val(newQuantity);
      /* Update the item */

      CartJS.updateItem(lineItemCount, newQuantity, {}, {
        success: function success(data, textStatus, jqXHR) {//console.log(data);
          // //Rebind the line item price
          // reloadAjaxCartItemUsingCartAjaxObject(data);
        },
        error: function error(jqXHR, textStatus, errorThrown) {//console.log("Error: " + errorThrown + "!");
        },
        complete: function complete(jqXHR, textStatus, errorThrown) {//console.log(jqXHR);
          //console.log(textStatus);
          //console.log(errorThrown);
        }
      });
    } else {
      /* Show a message out of stock */
      $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__out-of-stock").html("Out of stock");
      $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__out-of-stock").show();
      $(".js__cart-table-item-row ").filter('[data-cart-line-count="' + lineItemCount + '"]').find(".js__out-of-stock").delay(2000).fadeOut();
    }
  }
} //REMOVE ITEM via lineItemCount


function removeItem(lineItemCount) {
  CartJS.removeItem(lineItemCount, {
    success: function success(data, textStatus, jqXHR) {},
    error: function error(jqXHR, textStatus, errorThrown) {//console.log('Error: ' + errorThrown + '!');
    }
  });
} // REMOVE ITEM via variantID
//REMOVE ITEM


function removeItemById(variantID) {
  CartJS.removeItemById(variantID, {
    success: function success(data, textStatus, jqXHR) {},
    error: function error(jqXHR, textStatus, errorThrown) {//console.log('Error: ' + errorThrown + '!');
    }
  });
} //RELOAD AJAX CART


function reloadAjaxCartItemUsingCartAjaxObject(data) {
  var lineCount = 1;
  var cartObject; //console.log(data);

  if (data == undefined) {
    cartObject = CartJS.cart;
  } else {
    cartObject = data;
    quickCartTotal(data);
  }

  $(".js__ajax-products-bind").html("");
  $(".cart-list").html("");
  $(cartObject.items).each(function () {
    var imageURL = this.featured_image.url;
    var imageAlt = this.featured_image.alt;
    var itemPrice = this.original_price;
    var itemLinePriceTotal = this.line_price;
    var handle = this.handle;
    var itemID = this.id;
    var itemPriceAfterDiscount = this.discounted_price;
    var comparePrice = "";
    var disabled = "";
    var finalLineItemPrice = this.final_line_price;
    var cartBundleBoxID = "";
    var boolPromoOffer = false;
    /*Bundle Free Bag Product*/

    if (this.properties != null) {
      itemProperties = this.properties;

      if (Object.keys(itemProperties).length > 0) {
        $.each(itemProperties, function (key, value) {
          /* If box ID exists, then remove quantity + -  working */
          if (key == boxID) {
            cartBundleBoxID = value;
          }

          if (key == "_promoOffer") {
            boolPromoOffer = true;
          }
        });
      }
    }
    /* get compare price using cartLib object */


    if (typeof cartLib !== "undefined") {
      $.each(cartLib, function (key, value) {
        //console.log(value);
        if (value["id"] == itemID) {
          comparePrice = value["comparePrice"];
        }
      });
    }

    var hideElementClass = "";
    /*For contribution item*/

    if (handle == "donation") {
      hideElementClass = " hide ";
    }
    /* FORMATTED PRICING */


    var formattedcomparePrice = comparePrice / 100;
    formattedcomparePrice = formatter.format(formattedcomparePrice); //console.log(imageURL);
    // check if the compared price is greater then item price then only show the compared price

    var comparePriceHtml = "";

    if (comparePrice > parseFloat(itemPrice)) {
      comparePriceHtml = "<s>" + formattedcomparePrice + "</s>";
    } // total compared price for the item with quantity


    var totalListItemComparePrice = comparePrice * this.quantity;
    totalListItemComparePrice = totalListItemComparePrice / 100;
    totalListItemComparePrice = formatter.format(totalListItemComparePrice); // item original price

    var formattedItemPrice = itemPrice / 100;
    formattedItemPrice = formatter.format(formattedItemPrice); // line price

    var formattedItemLinePriceTotal = itemLinePriceTotal / 100;
    formattedItemLinePriceTotal = formatter.format(formattedItemLinePriceTotal); //final line item price

    var formattedFinalLineItemPrice = finalLineItemPrice / 100;
    formattedFinalLineItemPrice = formatter.format(formattedFinalLineItemPrice); //console.log("formattedItemLinePriceTotal: " + formattedItemLinePriceTotal);
    //Price after discount

    var showPrice = "";
    var itemPriceAfterDiscountStatus = false;
    var discountedMessage = "";
    var discountedMessageElement = "";

    if (this.discounts != null) {
      discountedMessage = this.discounts;

      if (Object.keys(discountedMessage).length > 0) {
        //console.log("DISCOUNT EXISTS");
        discountedMessageElement = "<span class='discountedMessage'>";
        $.each(discountedMessage, function (key, value) {
          discountedMessageElement += value.title;
        });
        discountedMessageElement += "</span>";
      }
    }

    var formattedItemPriceAfterDiscount;
    formattedItemPriceAfterDiscount = itemPriceAfterDiscount / 100;
    formattedItemPriceAfterDiscount = formatter.format(formattedItemPriceAfterDiscount); // if itemPriceAfterDiscount > 0 then set the status to true so you can interchange the values

    if (this.discounts.length > 0) {
      itemPriceAfterDiscountStatus = true;
    }

    var miniCartPrice = ""; //console.log("itemPriceAfterDiscount STATUS: " + itemPriceAfterDiscountStatus)
    // if it's true; then show the compared price as the main price this.price and main price as discounted price

    if (itemPriceAfterDiscountStatus) {
      //comparePriceHtml
      showPrice = '<span class="price-wrapper js__raw-line-item-price ' + hideElementClass + '"  data-attr-compare-price="0"><s>' + formattedItemPrice + '</s><span class="price" data-key="' + itemID + '">' + formattedItemPriceAfterDiscount + "</span><span class='forMiniCart'>" + formattedFinalLineItemPrice + "</span></span>" + discountedMessageElement;
      miniCartPrice = "<div class='price-section'><span class='price'>" + formattedItemPriceAfterDiscount + "</span><s>" + formattedItemPrice + "</s></div>";
    } else {
      showPrice = '<span class="price-wrapper  js__raw-line-item-price ' + hideElementClass + '"  data-attr-compare-price="0">' + comparePriceHtml + '<span class="price" data-key="' + itemID + '">' + formattedItemPrice + "</span><span class='forMiniCart'>" + formattedFinalLineItemPrice + "</span></span>";
      miniCartPrice = "<div class='price-section'><span class='price'>" + formattedItemPrice + "</span>" + comparePriceHtml + "</div>";
    }

    if (handle == "donation") {
      miniCartPrice = "<div class='price-section'><span class='price'>" + formattedFinalLineItemPrice + "</span></div>";
    } //console.log("showPrice" + showPrice);
    //console.log("miniCartPrice" + miniCartPrice);

    /* Bind the properties */


    var itemProperties = "";
    var itemPropertiesElement = "";
    var itemPropertiesMainElement = "";
    var boolItemBoxType = false;
    var readonly = "";
    var justifyCenter = "";
    var formattedItemPriceMiniCart = formattedItemPrice;
    /* Item properties */

    if (this.properties != null) {
      itemProperties = this.properties; //console.log(itemProperties);

      if (Object.keys(itemProperties).length > 0) {
        itemPropertiesElement = "<ul>";
        $.each(itemProperties, function (key, value) {
          /* If box ID exists, then remove quantity + -  working */
          if (key == boxID) {
            // CUSTOM: 2 below lines are used if you want to remove the quantity + -
            // hideElementClass = "hide";
            // readonly = "readonly='readonly'";
            boolItemBoxType = true;
            justifyCenter = "justify-center "; // CUSTOM: if you do not want to show the price and compared price in cart and mini cart then open the below variables
            // formattedItemPrice="-";
            // formattedcomparePrice="-";
            // formattedItemLinePriceTotal="-";
            // formattedItemPriceMiniCart="";
          }

          if (key.indexOf("_") > -1) {} else {
            if (key != boxID) {
              itemPropertiesElement += "<li class='flex'><span>" + key + ": </span><span style='padding-left: 5px'>" + value + "</span>";
              itemPropertiesElement += "</li>";
            }
          } // Recharge - when subscription is via properties for older recharge version before November 2020


          recharge2020(key, value);
        }); // Recharge 2020, check if it's a subscription, then bind the value in the UL

        if (recurringchecked) {
          itemPropertiesElement += "<li class='flex'><span>Recurring Delivery every " + frequency + " " + frequency_unit + ". Change or cancel anytime</span>";
          itemPropertiesElement += "</li>";
        }

        itemPropertiesElement += "</ul>"; //console.log(itemPropertiesElement);

        itemPropertiesMainElement = itemPropertiesElement;
      } else {
        itemPropertiesElement = "";
      }
    }

    var sellingPlayInformation = "";

    if (this.selling_plan_allocation != undefined) {
      sellingPlayInformation = this.selling_plan_allocation.selling_plan.name;
    }
    /* check if variantTitle is NULL, then don't show variant */


    var variantTitle = this.variant_title;

    if (variantTitle == null) {
      variantTitle = "";
    }
    /* CUSTOM - if the product title contains "bag",  then disabled the quantity element
    To be applied for all the products with BoxID and Promo Offer
    */
    // if (this.product_title.toLowerCase() == "bag") {


    if (this.product_title.toLowerCase().indexOf("bag") >= 0 && cartBundleBoxID != "" || this.product_title.toLowerCase().indexOf("bag") >= 0 && boolPromoOffer) {
      //if you want to hide the quantity + - then enable the class below
      // hideElementClass="hide"
      justifyCenter = "justify-center ";
      readonly = "readonly='readonly'";
      disabled = "disabled ";
    }
    /* 
    LINE ITEM FOR THE MINI CART
    */
    //elements
    // remove anchor


    var removeAnchorElement = '<div class="remove js__cart-item-remove ' + removeExtraClass + '" data-cart-line-count="' + lineCount + '" data-variant-id="' + itemID + '"  data-cart-remove-variant="' + this.id + '" data-cart-line-count=' + lineCount + ">" + removeMiniCartTextOrIcon + "</div>"; //quantity element

    var quantityElement = '<div class="cart-quantity-outer ' + hideElementClass + ' ' + disabled + justifyCenter + '"> <a  tabindex="0"  class="minus-qty ' + hideElementClass + '  font-zero" onclick="minusQuantity(' + lineCount + ')"   data-variant-id="' + itemID + '">' + minusIcon + '</a> <input aria-label="Quantity"  tabindex="-1"  data-limit="' + boolItemBoxType + '"  ' + readonly + '   onkeydown="return isNumeric(event);" type="text"  data-attr-raw-variant-quantity="94" data-cart-line-count="' + lineCount + '" class="cart__quantity-selector js__cart__quantity-selector" name="updates[]" id="updates_' + itemID + '" value="' + this.quantity + '" maxlength="3" size="3"> <a  tabindex="0"  class="plus-qty ' + hideElementClass + '  font-zero" onclick="plusQuantity(' + lineCount + ')"     data-variant-id="' + itemID + '">' + plusIcon + "</a> </div>"; //vendor element

    var vendorElement = '<span class="subheading uppercase">' + this.vendor + "</span>";
    var lineItem;
    lineItem = '<li class="flex-wrap js__cart-table-item-row" data-cart-line-count=' + lineCount + ' data-handle="' + handle + '" data-variant-id=' + itemID + '><div class="image-section"> <a href="' + this.url + '"><img alt="' + imageAlt + '" src="' + imageURL + '""> </a> </div>';
    lineItem += '<div class="content"><h5><a href="' + this.url + '">' + this.product_title + "</a></h5>" + removeAnchorElement + "";

    if (sellingPlayInformation != "") {
      lineItem += '<p class="capitalize">' + sellingPlayInformation + "</p>";
    }

    if (itemPropertiesElement != "") {
      lineItem += '<p class="capitalize">' + itemPropertiesElement + "</p>";
    }

    if (variantTitle != "") {
      lineItem += '<p class="capitalize">' + variantTitle + "</p>";
    }

    lineItem += showPrice + '<div class="flex-space-between"><p class="hide">Qty ' + this.quantity + "</p>" + quantityElement; //lineItem += removeAnchorElement + "</div></div>";
    // !! NEED TO CHECK WITH DEV - why we using this variable here

    lineItem += miniCartPrice + "</div></div>";
    lineItem += "</li>";
    /* Bind the line item to the list */

    $(".js__ajax-products-bind").append(lineItem); //LINE ITEM FOR THE CART PAGE

    if ($(".cart-list")[0]) {
      //classLineItem = ".js__set-line-item-price";
      var cartLineItem = "";
      cartLineItem = '<div class="cart-list__items cart-table-body js__cart-table-item-row flex" data-cart-line-count="' + lineCount + '" data-attr-compare-price="" data-variant-id="' + itemID + '"><div class="cart-list__items__columns"><div class="image-section "><img class="img-responsive img-thumbnail item-image" src="' + imageURL + '" alt="' + imageAlt + '"></div> <div class="content">'; // show vendor on cart page

      if (showVendorOnCartPage) {
        cartLineItem += vendorElement;
      }

      cartLineItem += '<a class="item-name" href="' + this.url + '"> <span class="item-title">' + this.product_title + " </span></a>";
      cartLineItem += '<div class="cart-list__variant-properties">';

      if (sellingPlayInformation != "") {
        cartLineItem += '<span class="capitalize">' + sellingPlayInformation + "</span>";
      }

      if (itemPropertiesElement != "") {
        cartLineItem += '<span class="capitalize">' + itemPropertiesElement + "</span>";
      }

      if (variantTitle != "") {
        cartLineItem += '<span class="capitalize">' + variantTitle + "</span>";
      }

      cartLineItem += "</div>";
      cartLineItem += '<a class="remove btn-border-small-black " title="Remove" data-cart-line-count="' + lineCount + '" data-variant-id="' + itemID + '" href="javascript:;">remove</a>  </div>  </div>  <div class="cart-list__items__columns">';
      cartLineItem += showPrice;
      cartLineItem += "</div>";
      cartLineItem += '<div class="cart-list__items__columns quantity" data-variant-id="' + itemID + '"> ' + quantityElement + '  <span class="js__out-of-stock"></span>'; // ** Remove action is added here too

      cartLineItem += ' </div>';
      cartLineItem += '<div class="cart-list__items__columns total-price price-wrapper" data-head="Total"> <span class="js__set-line-item-price" data-attr-price="' + itemPrice + '" data-attr-compare-price=' + totalListItemComparePrice + '><s class="hide">' + totalListItemComparePrice + '</s><span class="price" data-key="' + itemID + '">' + formattedItemLinePriceTotal + "</span> </span>"; // ** Remove element is added here too
      //cartLineItem +="<a class=' remove btn-border-small-black ipad-block ' data-cart-line-count='" +lineCount +"' data-variant-id='" +itemID +"' href='javascript:;'>remove</a> ";

      cartCountEmptyValue += " </div></div>";
      $(".cart-list").append(cartLineItem);
    }

    lineCount++;
  });
} //CALCULATE TOTAL OF THE CART


function quickCartTotal(data) {
  if (data == undefined) {
    cartObject = CartJS.cart;
  } else {
    cartObject = data;
  }

  var total = cartObject.items_subtotal_price;
  total = total / 100;
  total = formatter.format(total);
  $(".js__cart-total").html(total);
  $(".js__ajax-cart-total").html("" + total);
  $(".js__ajax-cart-total").show();
  $(".js__ajax-cart-count").html(cartObject.item_count);
  $(".js__top-cart-form-actions").show();
  $(".js__cart-expand ").removeClass("empty-cart");
}

function calculateSubTotalWithDiscount() {
  var subTotal = 0;
  var discount = 0;
  var total = 0;
  var lineItemComparePrice = 0;
  var itemPrice = 0;
  var quantity = 0;
  /* loop through eachcart item and get the compared price and actual price */

  if (typeof cartLib !== "undefined") {
    $.each(cartLib, function (key, value) {
      quantity = parseInt(value.quantity); //console.log("quantity: " + quantity);

      if (value.comparePrice != "") {
        lineItemComparePrice = parseInt(value.comparePrice) * quantity + lineItemComparePrice;
        console.log("lineItemComparePrice: " + lineItemComparePrice);
      } else {
        lineItemComparePrice = parseInt(value.price) * quantity;
      }

      itemPrice = parseInt(value.price) * quantity; //console.log("itemPrice: " + itemPrice);

      subTotal += lineItemComparePrice; //console.log("subTotal: " + subTotal);

      discount += lineItemComparePrice - itemPrice; //console.log("discount: " + discount);
    });
    total = CartJS.cart.total_price; //format

    subTotal = subTotal / 100;
    subTotal = formatter.format(subTotal);
    discount = discount / 100;
    discount = formatter.format(discount);
    total = total / 100;
    total = formatter.format(total);
  }

  if (CartJS.cart.item_count > 0) {
    $(".js__cart-sub-total").html(subTotal);
    $(".js__cart-total-saved").html("-" + discount);
    $(".js__cart-total").html(total);

    if (showCartCountInTopNav) {
      $(".js__ajax-cart-count").show();
      $(".js__ajax-cart-count").html(CartJS.cart.item_count);
    }

    $(".free-shipping").show(); //show/hide js__cartSubtotalDiscountWraper - if you want to show subtotal and discount

    showCartSubTotalDiscountSection ? $(".js__cartSubtotalDiscountWraper").removeClass("hide") : console.log("SubTotal Discount Wrapper: NOT visible");
  } else {
    /* 
    update cart item count = 0
    hide the totals
    hide checkout buttons
    update the icon cart with a different icon
    */
    $(".js__ajax-products-bind").html('<li><div class="width-100"> <p class="uppercase text-center">Your cart is empty</p> </div></li>');
    //$(".freq-product-list").hide();
    $(".free-shipping").hide();
    $(".js__ajax-cart-count").html(cartCountEmptyValue);
    $(".js__ajax-cart-total").hide();
    $(".js__top-cart-form-actions").hide();
    $(".js__show-cart-items-section").hide();
    $(".empty-cart-section").show();
    setTimeout(function () {
      $(".js__home-collection-slider").slick("refresh");
    }, 1000);
    $(".js__cart-expand ").addClass("empty-cart"); //change the icon for the top cart, if required

    showEmptyCartIcon ? $(".js__update-cart-icon").addClass("empty-cart") : console.log("Top Cart Icon: NOTchanged");
  }
}
/*
  CUSTOM-- for the BUILDER
  THIS FUNCTION IS USED WHEN THERE IS NO QUANTITY BOX VISIBLE AGAINST THE ITEM
  //Variest from theme to theme
   1. Loop through cart items
   2. If item has property > 0 
   3. Then check for boxID 
   4. Save the BoxID in a variable
   5. Then go through the second cart item
   6. if currentItemPropertyBoxID = savedItemPropertyBoxID
   7. Then remove the item
   8. Else do not do anything
*/


var savedItemPropertyBoxID = "";
var currentItemPropertyBoxID = "";
var clickedRemoveItemStatus = false;
var currentItemID = "";
$(document).on("click", ".remove", function () {
  //console.log("REMOVE CLICKED");
  var howManyItemsToDelete = 0;
  var howManyVariantIDToDelete = [];
  var variantID = parseInt($(this).attr("data-variant-id"));
  var itemLineCount = parseInt($(this).attr("data-cart-line-count")); //console.log("itemLineCount: " + itemLineCount);

  var extraItemLineCount = 1;
  /* offer main product ID and bool*/

  var productID = ""; //Run properties loop and set clickRemove status = true if BoxID is found

  $(CartJS.cart.items).each(function () {
    if (itemLineCount == extraItemLineCount) {
      //console.log("clicked - variantID : " + variantID);
      productID = this.product_id;
      $.each(this.properties, function (key, value) {
        //console.log("key: " + key);
        if (key == boxID) {
          //console.log("key2: " + key);
          savedItemPropertyBoxID = value;
          clickedRemoveItemStatus = true;
        }
        /* CUSTOM: Checking deleted item is main product of promo offer*/


        if (key == "_promoOffer") {
          if (productID == promoOffer_BlackFriday_ProductID) {
            boolPromoOffer_BlackFriday_ProductID = true;
          }
        }
      });
    }

    extraItemLineCount = extraItemLineCount + 1; //console.log("clickedRemoveItemStatus: " + clickedRemoveItemStatus);

    if (clickedRemoveItemStatus) {
      //console.log("clickedRemoveItemStatus: " + true);
      clickedRemoveItemStatus = false;
      return false;
    }
  });
  extraItemLineCount = 1;
  /* CUSTOM: Loop through items and properties */

  $(CartJS.cart.items).each(function () {
    currentItemID = this.id; //console.log("LoopCurrentItemID: " + currentItemID);

    $.each(this.properties, function (key, value) {
      //console.log("key4: " + key);
      //console.log("boxID4: " + boxID);
      if (key == boxID) {
        //console.log("Property Match");
        currentItemPropertyBoxID = value; //console.log("currentItemPropertyBoxID: " + currentItemPropertyBoxID);
        //console.log("savedItemPropertyBoxID: " + savedItemPropertyBoxID);

        if (currentItemPropertyBoxID == savedItemPropertyBoxID) {
          //console.log("remove the current item");
          extraItemLineCount = 1;
          howManyItemsToDelete = howManyItemsToDelete + 1;
          howManyVariantIDToDelete.push(currentItemID); //Remove the product that clicked
        } else {
          extraItemLineCount = extraItemLineCount + 1;
        }
      } else {//console.log("BOX ID ISN'T THERE IN PRODUCT");
        //removeItem(itemLineCount);
      }
    }); //console.log("howManyVariantIDToDelete: " + howManyVariantIDToDelete);
  }); //console.log("TOTAL: howManyVariantIDToDelete: " + howManyVariantIDToDelete);
  //console.log("TOTAL howManyItemsToDelete: " + howManyItemsToDelete);

  if (howManyItemsToDelete == 0) {
    //console.log("ITEM TO DELETE: " + 0);
    removeItem(itemLineCount);
  } else {
    //console.log("TOTAL # of item to delete > 0");

    /* 
    Remove the items depending upon how many are to be deleted
    Run the loop again and delete them one by one 
    */
    //console.log(howManyVariantIDToDelete.length);
    var currentItemLoop = 1; // NOTE: used "removeItemById" as for this particular project ..

    for (var n = 0; n < howManyVariantIDToDelete.length; ++n) {
      removeItemById(howManyVariantIDToDelete[n]); //debugger;
      // $(CartJS.cart.items).each(function () {
      //   //console.log("howManyVariantIDToDelete");
      //   //console.log(howManyVariantIDToDelete[n]);
      //   //console.log(this.title);
      //   //console.log(this.properties);
      //   //debugger;
      //   if (jQuery.isEmptyObject(this.properties)) {
      //     //console.log("Property is empty");
      //     currentItemLoop = currentItemLoop + 1;
      //   } else {
      //     $.each(this.properties, function (key, value) {
      //       if (key == boxID ) {
      //         //console.log("FINAL - BOX ID FOUND 1 by 1");
      //         currentItemPropertyBoxID = value;
      //         if (currentItemPropertyBoxID == savedItemPropertyBoxID) {
      //           //console.log("remove the final loop item");
      //           removeItemById(howManyVariantIDToDelete[n]);
      //           currentItemLoop = 1;
      //           //Remove the product that clicked
      //         } else {
      //           currentItemLoop = currentItemLoop + 1;
      //         }
      //       }
      //       else
      //       {
      //         //console.log("FINAL - BOX ID NOT FOUND 1 by 1");
      //       }
      //     });
      //     if (currentItemLoop == 1) {
      //       return false;
      //     }
      //   }
      // });
    }
  }

  showHideEmptyCart();
});

function showHideEmptyCart() {
  if (CartJS.cart.item_count == 0) {
    $(".empty-cart-section").show();
    $(".js__show-cart-items-section").hide();
    $("#shopify-section-cart-recommendations").hide();
  } else {
    $(".empty-cart-section").hide();
  }
}
/*
PROGRESS BAR
*/


function progressBar() {
  if (showProgressBar) {
    var totalAmount = CartJS.cart.total_price / 100;
    var freeShippingAmount = parseFloat($(".js__free-shipping-limit").html());
    var freeShippingRemaningAmount = freeShippingAmount - totalAmount;
    var freeShippingPercentage = 100;

    if (freeShippingRemaningAmount > 0) {
      freeShippingPercentage = totalAmount * 100 / freeShippingAmount;
      $(".js__free-shipping-limit-message").show();
      $(".js__free-shipping-message").hide();
    } else {
      $(".js__free-shipping-limit-message").hide();
      $(".js__free-shipping-message").show();
    }

    $(".js__free-shipping-remaning-amount").html(formatter.format(freeShippingRemaningAmount));
    $(".js__free-shipping__progress-bar").attr("data-percentage", freeShippingPercentage);
    $(".js__free-shipping__progress-bar").children("span").css("width", freeShippingPercentage + "%");
  }
}
/*
ADDONS
NOTE:: CONFUSING CODE FOR THE ADDONS - WILL NEED TO CLEAN IT A BIT
1. Try to get all the addon handles for the items which are in the cart
2. Create an array for item>addon
3. Loop through all the cart items and addon
4. CHECK - if addon is already there in the list, then the same 2nd addon should not be visible
*/

/* Old Sidebar FBT Addon code
$(document).ready(function ($) {
  $(".js__addon-add-to-cart").click(function () {
    var quantity = 1;
    var addonSelectedVariantID = $(this).attr("data-attr-variantid");
    cartAddItemAddon(addonSelectedVariantID, quantity);
  });
  $(".js__addon-add-to-cart").keypress(function () {
    var keycode = event.keyCode || event.which;

    if (keycode == "13") {
      event.preventDefault();
      var quantity = 1;
      var addonSelectedVariantID = $(this).attr("data-attr-variantid");
      cartAddItemAddon(addonSelectedVariantID, quantity);
    }
  });
});

function cartAddItemAddon(addonSelectedVariantID, addonQuantity) {
  CartJS.addItem(addonSelectedVariantID, addonQuantity, {}, {
    success: function success(data, textStatus, jqXHR) {//console.log("success");

      
    },
    error: function error(jqXHR, textStatus, errorThrown) {//console.log("error");
    }
  });
}
*/

/* old sidebar cart FBT addons code
function addons() {
  //console.log("addons");
  
  var cartAddons = "";
  $(".js__top-cart-addons li").each(function (index) {
    // update this with variantID
    var addoneHandle = $(this).attr("data-handler"); // if cartAddon is null,

    if (cartAddons == "") {
      // save the addonHandle
      cartAddons = addoneHandle;
    } else {
      //set bool value to see if the addons is present in the addon list or not
      // by default it's false
      var boolCartAddons = false; // going through the string and checking if the current addon handle = the addon
      //handle present in the string

      var cartAddons2 = cartAddons.split(",");

      for (var a = 0; a < cartAddons2.length; a++) {
        if ($(this).attr("data-handler") == cartAddons2[a]) {
          // if present, then hide it
          $(this).hide();
          boolCartAddons = true;
        }
      } // add the new addon handle to the string


      if (boolCartAddons == false) {
        cartAddons = cartAddons + "," + addoneHandle;
      }
    } //console.log(cartAddons);

    var boolItemCartAddon = false;
    $(".js__ajax-products-bind li").each(function (index) {
      var itemHandle = $(this).attr("data-handle"); //console.log("itemHandle"+itemHandle);
      //console.log("addoneHandle"+addoneHandle)

      if (addoneHandle == itemHandle) {
        boolItemCartAddon = true;
      }
    });

    if (boolItemCartAddon == true) {
      $(this).hide();
    } else {
      $(this).show();
    }
  });

  var boolAddonExist = false;
  $(".js__top-cart-addons li").each(function (index) {
    if ($(this).css("display") != "none") {
      boolAddonExist = true;
    }
  }); //console.log("boolAddonExist"+boolAddonExist);

  if (boolAddonExist == false) {
    //console.log("if");
    $(".js__freq-bought-products").hide();
  } else {
    //console.log("else");
    $(".js__freq-bought-products").show();
  }
} //Addons are fetched from the schemas; Varies from theme to theme

*/

/*
setTimeout(function () {
  addons();
}, 1000); //loop through cart items to get property on the basis of variant ID
*/

function loopThroughCartItems_on_VariantID(variantID) {
  var currentVariantID = "";
  var properties = "";
  $(CartJS.cart.items).each(function () {
    // currentVariantID = this.id;
    if (variantID == this.id) {
      properties = this.properties;
      return false;
    }
  });
  return properties;
}

function loopThroughCartItems_on_ProductID(productID) {
  var variantID = "";
  $(CartJS.cart.items).each(function () {
    // currentVariantID = this.id;
    if (productID == this.product_id) {
      variantID = this.id;
      return false;
    }
  });
  return variantID;
}

function recharge2020(key, value) {
  if (key == "shipping_interval_frequency") {
    frequency = value;
    recurringchecked = "true";
  }

  if (key == "shipping_interval_unit_type") {
    if (frequency == "1") {
      if (value == "Days") {
        frequency_unit = "Day";
      } else if (value == "Months") {
        frequency_unit = "Month";
      } else if (value == "Weeks") {
        frequency_unit = "Week";
      }
    } else {
      frequency_unit = value;
    }
  }
}
"use strict";

jQuery(function () {
  /*Pagination number*/
  $(".pagination span").each(function () {
    if ($(this).html().trim() == "…") {
      $(this).removeClass("current");
    }
  });

  try {
    var pageTotal = parseInt($(".js__total-page").val());
    var currentPage = parseInt($(".js__current-page").val());
    var itemTotal = parseInt($(".js__items-count").val());
    var perPageItem = parseInt($(".js__perpage-item").val());
    var itemStart = 1;
    var itemEnd = 0;

    if (currentPage > 1) {
      itemStart = perPageItem * (currentPage - 1) + 1;
    }

    itemEnd = itemStart + perPageItem - 1;

    if (pageTotal == currentPage) {
      itemEnd = itemTotal;
    }

    $(".js__page-range").html(itemStart + " - " + itemEnd);
  } catch (_unused) {}
  /* SLIDER */

  /* Hero Banner SLider */


  $(".js__hero-slider").not(".slick-initialized").slick({
    dots: true,
    slidesToShow: 1,
    arrows: true,
    infinite: true,
    speed: 500,
    draggable: false,
    cssEase: "ease-in-out",
    autoplay: false,
    adaptiveHeight: true
  });
  $(window).on("resize", function () {
    $(".js__hero-slider").slick("refresh");
  });
  /*Team popup*/

  $(".js__team-popup-open").click(function () {
    var name = $(this).parent("li").children("h5").html();
    var description = $(this).parent("li").children(".description").html();
    $(".js__team-popup-content").children("h2").html(name);
    $(".js__team-popup-content").children(".content").html(description);
    $(".js__team-popup").show();
  });
  $(".js__modal-close").click(function () {
    $(".modal").hide();
  });
  /* Add to cart working for product cart */

  $(".js__btn-add-to-cart").click(function () {
    if ($(this).html().trim().toLowerCase() == "add to cart") {
      var selectedVariantID = $(this).attr("data-attr-itemid");
      selectedVariantID = parseInt(selectedVariantID);
      var cartSuccess = false;
      var quantity = 1;
      var items = [];
      /* For the main item */

      items.push({
        id: selectedVariantID,
        quantity: quantity
      });
      CartJS.addItems(items, {
        success: function success(response, textStatus, jqXHR) {
          CartJS.getNote();
          console.log(response); // console.log(CartJS.cart);

          cartSuccess = true;

          if (getglobalLib("Mini_Cart") == "yes") {
            /* Show message */
            setTimeout(openMiniCart, 500);
          } else {
            window.location = "/cart";
          }
        },
        // Define an error callback to display an error message.
        error: function error(jqXHR, textStatus, errorThrown) {
          showCartErrorMessage();
        }
      });
    }
  });
  /*Home collection slider*/

  $(".js__home-collection-slider").not(".slick-initialized").slick({
    dots: false,
    slidesToShow: 4,
    arrows: true,
    infinite: true,
    speed: 500,
    draggable: false,
    cssEase: "ease-in-out",
    autoplay: false,
    adaptiveHeight: true,
    responsive: [{
      breakpoint: 981,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 769,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 481,
      settings: {
        slidesToShow: 1
      }
    }]
  });
  /*Home blog slider*/

  $(".js__home-blog-slider").not(".slick-initialized").slick({
    dots: false,
    slidesToShow: 4,
    arrows: true,
    infinite: true,
    speed: 500,
    draggable: false,
    cssEase: "ease-in-out",
    autoplay: false,
    adaptiveHeight: true,
    responsive: [{
      breakpoint: 981,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 769,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 481,
      settings: {
        slidesToShow: 1
      }
    }]
  });
  /*Compare collection slider*/

  var $slider = $(".js__compare-collection-slider");
  var $progressBar = $(".js__compare-table-progress-bar");
  var $progressBarLabel = $(".slider__label");
  $slider.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
    var calc = nextSlide / (slick.slideCount - 1) * 100;
    $progressBar.css("background-size", calc + "% 100%").attr("aria-valuenow", calc);
    $progressBarLabel.text(calc + "% completed");
  }); // Custom carousel nav

  $(".js__custom-slider-prev").click(function () {
    $(this).parent().find($slider).slick("slickPrev");
  });
  $(".js__custom-slider-next").click(function (e) {
    e.preventDefault();
    $(this).parent().find($slider).slick("slickNext");
  });
  $slider.not(".slick-initialized").slick({
    slidesToScroll: 2,
    dots: false,
    arrows: true,
    infinite: false,
    speed: 500,
    draggable: true,
    cssEase: "ease-in-out",
    autoplay: false,
    variableWidth: true
  });
  /*Related Article slider*/

  $(".js__realated-articles").not(".slick-initialized").slick({
    dots: false,
    slidesToShow: 4,
    arrows: true,
    infinite: true,
    speed: 500,
    draggable: false,
    cssEase: "ease-in-out",
    autoplay: false,
    adaptiveHeight: true,
    responsive: [{
      breakpoint: 981,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 769,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 481,
      settings: {
        slidesToShow: 1
      }
    }]
  });

  
  $(".js__half-content-half-image-slider-with-tab").not(".slick-initialized").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: false,
    infinite: false,
    adaptiveHeight: false,
    variableWidth: false,    
    responsive: [{
      breakpoint: 768,
      settings: "unslick"
    }]
  });
  
  /*Article Product slider*/

  $(".js__article-product-slider").not(".slick-initialized").slick({
    dots: false,
    slidesToShow: 3,
    arrows: true,
    infinite: true,
    speed: 500,
    draggable: false,
    cssEase: "ease-in-out",
    autoplay: false,
    adaptiveHeight: true,
    responsive: [{
      breakpoint: 981,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 769,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 481,
      settings: {
        slidesToShow: 1
      }
    }]
  });
  $(".js__testimonial-content-slider").not(".slick-initialized").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    infinite: false,
    adaptiveHeight: false,
    variableWidth: false,
    responsive: [{
      breakpoint: 769,
      settings: {
        dots: true
      }
    }]
  });
  $(".js__testimonial-logo-slider .slide:first-child").addClass("active");
  $(document).on("click", ".js__testimonial-logo-slider .slide", function (e) {
    e.preventDefault();
    var slideno = $(this).index();
    var child = slideno + 1;
    $(".js__testimonial-logo-slider .slide").removeClass("active");
    $(this).addClass("active");
    $(".js__testimonial-content-slider").slick("slickGoTo", slideno);
  });
  /*Auto rotate testimonial*/

  setInterval(function () {
    var slideno = $(".js__testimonial-logo-slider .slide.active").index();
    var child = slideno + 1;
    var count = $(".js__testimonial-logo-slider .slide").length;

    if (child < count) {
      child++;
    } else {
      child = 1;
    }

    $(".js__testimonial-logo-slider .slide:nth-child(" + child + ")").click();
  }, 3000);
  /* PDP
  PRoduct Recommendation SLider */

  $("#js-pdp-recommendation-slider").not(".slick-initialized").slick({
    dots: false,
    slidesToShow: 5,
    arrows: false,
    infinite: false,
    speed: 500,
    cssEase: "ease-in-out",
    autoplay: false,
    variableWidth: true,
    draggable: true
  });
  setTimeout(function () {
    $(".js__hero-slider").addClass("active");
    $(".js__realated-articles").addClass("active");
    $(".js__article-product-slider").addClass("active");
    $(".js__half-content-half-image-slider-with-tab").addClass("active");        
    $(".js__testimonial-content-slider").addClass("active");
    $("#js-pdp-recommendation-slider").addClass("active");
  }, 500);
  $(".tab-head li:first-child").children("a").addClass("active");
  $(".tab-content:first-child").addClass("active");
  /*Drop down*/

  $(".js__tab-selected").on("click", function () {
    if ($(".js__tab-head-section").css("display") == "none") {
      $(".js__tab-head-section").slideDown(300);
    } else {
      $(".js__tab-head-section").slideUp(300);
    }
  });
  $(".js__tab-head-section li").on("click", function () {
    var dataId = $(this).attr("data-attr");
    $(".js__tab-head-section li").removeClass("active");
    $(this).addClass("active");
    $(".js__home-collection-slider").slick("slickUnfilter");
    $(".js__home-collection-slider").slick("slickFilter", "." + dataId); // set the color swatch images when tab is click

    //setColorThumbImages();
    $(".js__compare-collection-slider").slick("slickUnfilter");
    $(".js__compare-collection-slider").slick("slickFilter", "." + dataId);
    $(".js__half-content-half-image-slider-with-tab").slick("refresh");

    if ($(window).width() < 769) {
      $(".js__tab-head-section").slideUp(300);
    }

    $(".js__tab-selected").html($(this).children("a").html());
  });

  function compareDataFixes() {
    /*Compare list each for each slide*/
    $(".js__compare-collection-slider  .slide").each(function (index) {
      var allList = "";
      var count = 1;
      var compareSlide = $(this);
      console.log("compareSlide" + compareSlide.html());
      /*Storing each slide compare data in variable and then remove that list */

      compareSlide.children(".js__compare-table-title").children("li").each(function (index) {
        if (count > 1) {
          if (allList == "") {
            allList = $(this).html();
          } else {
            allList = allList + "~" + $(this).html();
          }

          $(this).remove();
        }

        count++;
      });
      console.log("allList" + allList);
      var count2 = 1;
      /*Adding all list in each slide and which match added active class*/

      $("#js__compare-table-title li").each(function (index) {
        if (count2 > 1) {
          var leftTitle = $(this).html();
          var classActive = "";
          var allList2 = allList.split("~");

          for (var i = 0; i < allList2.length; i++) {
            if (allList2[i].toLowerCase().trim() == leftTitle.toLowerCase().trim()) {
              classActive = "active";
            }
          }

          compareSlide.children(".js__compare-table-title").append("<li class='" + classActive + "'></li>");
        }

        count2++;
      });
    });
  }

  var liText = "",
      liList = $("#js__compare-table-title li"),
      listForRemove = [];
  $(liList).each(function () {
    var text = $(this).text().toLowerCase();
    if (liText.indexOf("|" + text + "|") == -1) liText += "|" + text + "|";else listForRemove.push($(this));
  });
  $(listForRemove).each(function () {
    $(this).remove();
  });
  compareDataFixes();
  $(".js__tab-head-section li:first-child").click(); // $(".js__tab-head-section .tab-link").first().addClass("active");

  $(".collection-slider-with-tab .container-1320 .tab-content").first().show();
  $(".half-content-half-image-slider-with-tab .container-1320 .tab-content").first().show();
  /* PDP
  Tab working */

  $(".tab-link").on("click", function () {
    setTimeout(function () {
      $(".js__half-content-half-image-slider-with-tab").slick("refresh");
      $(".js__home-collection-slider").slick("refresh");
      $(".js__compare-collection-slider").slick("refresh");
    }, 0.001);
    var dataId = $(this).attr("data-attr");
    var i, tabcontent, tablink;
    tabcontent = document.getElementsByClassName("tab-content");

    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }

    tablink = document.getElementsByClassName("tab-link");

    for (i = 0; i < tablink.length; i++) {
      tablink[i].className = tablink[i].className.replace(" active", "");
    }

    document.getElementById(dataId).style.display = "block";
    event.currentTarget.className += " active";
  });
  /* GLOBAL
  Scroll to particular Div with # value */

  $('a[href^="#"]').on("click", function (event) {
    var target = $(this.getAttribute("href"));

    if (target.length) {
      event.preventDefault();
      $(".tab-head").hide();
      $("html, body").stop().animate({
        scrollTop: target.offset().top - 150
      }, 1000);
    }
  });
  /* accordion working about content in small screen*/

  $(".js__accordian").children("li").children("h5,h6").click(function (e) {
    if ($(this).parent("li").children(".content").css("display") == "none") {
      $(this).parent("li").parent(".js__accordian").children("li").children(".content").hide();
      $(this).parent("li").parent(".js__accordian").children("li").removeClass("active");
      $(this).parent("li").children(".content").slideDown();
      $(this).parent("li").addClass("active");
      /* $('html,body').animate({
        scrollTop: $(this).offset().top - 120
      }, 500);*/
    } else {
      $(this).parent("li").children(".content").slideUp();
      $(this).parent("li").removeClass("active");
    }
  });
  $(".js__pdp-tab-accordian").children("li").children("h5,h6").click(function (e) {
    if ($(window).width() > 768) {
      if ($(this).parent("li").children(".content").css("display") == "none") {
        $(this).parent("li").parent(".js__accordian").children("li").children(".content").hide();
        $(this).parent("li").parent(".js__accordian").children("li").removeClass("active");
        $(this).parent("li").children(".content").slideDown();
        $(this).parent("li").addClass("active");
        /* $('html,body').animate({
        scrollTop: $(this).offset().top - 120
        }, 500);*/
      } else {
        $(this).parent("li").children(".content").slideUp();
        $(this).parent("li").removeClass("active");
      }
    }
  });
  /* accordion working about content in small screen*/

  $(".js__pdp-accordian .inner").click(function (e) {
    if ($(this).parent("li").children(".content").css("display") == "none") {
      $(this).parent("li").children(".content").slideDown();
      $(this).parent("li").addClass("active");
      /* $('html,body').animate({
        scrollTop: $(this).offset().top - 120
      }, 500);*/
    } else {
      $(this).parent("li").children(".content").slideUp();
      $(this).parent("li").removeClass("active");
    }
  });
});
/** Dropdown **/

jQuery(function ($) {
  $(".js__dropdown_result").on("click", function () {
    if ($(".js__dropdown").css("display") == "none") {
      $(".js__dropdown").slideDown(300);
    } else {
      $(".js__dropdown").slideUp(300);
    }

    $(this).toggleClass("active");
  });
  var path = window.location.href; // because the 'href' property of the DOM element is the absolute path

  $(".js__custom-active-link li a").each(function () {
    if (this.href === path) {
      $(this).addClass("active");
    }
  });
  $(".js__dropdown li a").each(function () {
    if (this.href === path) {
      $(this).addClass("active");
      console.log($(this).html());

      if ($(this).html() != "view all") {
        $(".js__dropdown_result").html($(this).html());
      }

      $(".js__dropdown").slideUp(300);
      $(".js__dropdown_result").removeClass("active");
    } else {// $(".js__dropdown li").first.addClass("active");
    }
  });
});
/* Mini cart - Checkout Button visiblity fix for IOS Mobile */

var lastScroll = 0;
jQuery(document).ready(function ($) {
  $(".cart-sidebar__middle").addClass("safari-mobile");
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();

    if (scroll > lastScroll) {
      $(".cart-sidebar__middle").removeClass("safari-mobile");
    } else if (scroll < lastScroll) {
      $(".cart-sidebar__middle").addClass("safari-mobile");
    }

    lastScroll = scroll;
  });
});

function isNumber(evt) {
  evt = evt ? evt : window.event;
  var charCode = evt.which ? evt.which : evt.keyCode;

  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    return false;
  }

  return true;
}

jQuery(document).ready(function ($) {
  setTimeout(function () {
    console.log("boost-pfs-filter-top-sorting-select" + $("#boost-pfs-filter-top-sorting-select").val());

    if ($("#boost-pfs-filter-top-sorting-select").val() == null) {
      $("#boost-pfs-filter-top-sorting-select option:first-child").attr("selected", "selected");
    }
  }, 1000);
});
"use strict";

jQuery(function () {
  //Nav - Open and Close Mini cart
  if (getglobalLib("Mini_Cart") == "yes") {
    $(".js__cart-expand").on("click", function () {
      $("#CartSidebar").toggleClass("active");
      $("#cart_overlay").toggleClass("active");
      $(this).addClass("active");
    });
    $(".js__cart-close").on("click", function () {
      $("#CartSidebar").removeClass("active");
      $("#cart_overlay").removeClass("active");
      $(".js__cart-expand").removeClass("active");
    });
    $(".js__cart-expand").attr("href", "javascript:void(0)");
  }
  /* Cart - Free Shipping Progress bar Visiblity */


  if (getglobalLib("Free_Shipping_progressbar") == "yes") {
    $(".js__progressbar_visiblity").removeClass("hide");
  }
  /* Remove mini cart from the cart page */


  if ($(".cart-table-body")[0]) {
    $("#CartSidebar").remove();
    $("#cart_overlay").remove();
    $(".js__top-cart-form-actions").remove();
    $(".js__ajax-products-bind").remove();
    $(".mini-cart").removeClass("js__cart-expand");
    $(".mini-cart").attr("href", "/cart");
  }
  /* show no items in cart */


  if (CartJS.cart.item_count == 0) {
    $(".empty-cart-section").show();
    $(".js__show-cart-items-section").hide();
    $("#shopify-section-cart-recommendations").hide();
  } else {
    $(".empty-cart-section").hide();
  }
  /*Quantity Plus Minus for the textbox */


  $(".js__product-single__quantity .js__minus-qty").click(function () {
    decreaseQuantity();
  });
  $(".js__product-single__quantity .js__plus-qty").click(function () {
    increaseQuantity();
  });

  function increaseQuantity() {
    var productQuantity = $(".js__quantity-selector").val();
    productQuantity++;
    $(".js__quantity-selector").val(productQuantity);
  }

  function decreaseQuantity() {
    var productQuantity = $(".js__quantity-selector").val();

    if (productQuantity > 1) {
      productQuantity--;
    }

    $(".js__quantity-selector").val(productQuantity);
  }
});
/* 
NOTIFICATIONS SECTION
Show Noticiations On Success and Error
Note: This function isn't being used in every theme
Feel free to comment/uncomment as per the functionality
*/

function showCartSuccessMessage() {
  setTimeout(openMiniCart, 500);
  $("#cart-message").addClass("message-success");
  $("#cart-message").removeClass("message-error");
  $("#cart-message").html("Successfully added to cart!");
  $("#cart-message").show();
  setTimeout(function () {
    $("#cart-message").hide();
  }, 5000);
}

function showCartErrorMessage() {
  $("#cart-message").removeClass("message-success");
  $("#cart-message").addClass("message-error");
  $("#cart-message").html("Sorry! Seems like the product is out of stock");
  $("#cart-message").show();
  setTimeout(function () {
    $("#cart-message").hide();
  }, 5000);
}

function openMiniCart() {
  if (CartJS.cart.item_count > 0) {
    $("#CartSidebar").toggleClass("active");
    $("#cart_overlay").toggleClass("active");
  }
}
/* EVENT: When the cart request is completed everytime the below function is run */


$(document).on("cart.requestComplete", function (event, cart) {
  console.log("On cart request complete");
  reloadAjaxCartItemUsingCartAjaxObject(cart); //Progress Bar of shipping in cart and mini cart; Varies from theme to theme

  progressBar(); //Show and hide empty cart depending upon the cart items

  window.dispatchEvent( new Event("cartRequestComplete") );
  
  setTimeout(function () {
    calculateSubTotalWithDiscount();
    //addons();
  }, 1000);
}); // $(document).on("cart.requestStarted", function (event, cart) {console.log("Request started"); });
//$(document).on("cart.ready", function (event, cart) {});

/* currency formatter */

var formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2
});
"use strict";

jQuery(function () {
  /* Footer - Accordion Visiblity */
  if (getglobalLib("Footer_Accordion") == "yes") {
    $(".js__accordion-toggle-visiblity").addClass("accordion-toggle-footer");
    $(".js__accordion-content-visiblity").addClass("accordion-content-footer");
  }
  /* FAQ - Category Sidebar Visiblity */


  if (getglobalLib("FAQ_Side_Panel") == "yes") {
    $(".js__faq-category-side-panel").removeClass("hide");
  }

  if (getglobalLib("Product_Recommendation_Slider") == "on") {
    $("#js__pdp-recommendation-slider").not(".slick-initialized").slick({
      dots: false,
      slidesToShow: 4,
      arrows: true,
      infinite: true,
      speed: 500,
      draggable: false,
      cssEase: "ease-in-out",
      autoplay: false,
      adaptiveHeight: true,
      responsive: [{
        breakpoint: 981,
        settings: {
          slidesToShow: 3
        }
      }, {
        breakpoint: 769,
        settings: {
          slidesToShow: 2
        }
      }, {
        breakpoint: 481,
        settings: {
          slidesToShow: 1
        }
      }]
    });
  }
});
"use strict";

jQuery(function () {
  /* Global
  Announcement Slider */
  $(".js__announcement-slider").not(".slick-initialized").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    infinite: true,
    vertical: true,
    cssEase: "ease-in-out",
    adaptiveHeight: false
  });
  /* Announcement 
  Close on Click  */

  $("#announcement-close").on("click", function () {
    $(".announcement-bar").hide();
    $("body").removeClass("announcement-visible");
  });
  $(".js__location-dd span").on("click", function () {
    $(".js__location-dd").toggleClass("active");
    $(".js__location-dd").children("ul").slideToggle();
  });
  $(".js__back-submenu").on("click", function () {
    $(".big-nav-link").removeClass("active");
    $(".big-nav-link").parent(".has-big-nav").children(".big-nav").toggleClass("active");
    $(".big-nav-link").parent(".has-big-nav").children(".big-nav").removeClass("active");
    $(".js__submenu-has-child").removeClass("active"); // $(".js__submenu-has-child").find(".accordion-content-inner").hide();
  });
  $(".js__back-childsubmenu").on("click", function () {
    $(".accordion-content-inner").removeClass("active");
  });
  $(".js__submenu-has-child").children("span").on("click", function () {
    if ($(this).parent("li").hasClass("active")) {
      $(this).parent("li").removeClass("active");
      $(this).parent("li").find(".accordion-content-inner").removeClass("active");
    } else {
      $(".js__submenu-has-child").removeClass("active");
      $(".js__submenu-has-child").find(".accordion-content-inner").removeClass("active");
      $(this).parent("li").addClass("active");
      $(this).parent("li").find(".accordion-content-inner").addClass("active");
    }
  });
  /* MEGAMENU
    active link while submenu open */
  // $(window).resize(function(){location.reload();});
  // in mobile on hover - desktop settings won't reflect

  if ($(window).width() > 980) {
    $(".js__submenu-has-child").first().addClass("active");
    $(".has-sub-nav-0 .site-nav__link,.has-sub-nav-0 .sub-nav").mouseover(function () {
      $(".js__main-header").addClass("active");
      $(".has-sub-nav-0 .site-nav__link").addClass("hover-submenu");
      $(".has-sub-nav-0 .sub-nav").css("visibility", "visible");
      $(".has-sub-nav-0 .sub-nav").css("opacity", "1");
    });
    $(".has-sub-nav-0 .site-nav__link,.has-sub-nav-0 .sub-nav").mouseout(function () {
      $(".js__main-header").removeClass("active");
      $(".has-sub-nav-0 .site-nav__link").removeClass("hover-submenu");
      $(".has-sub-nav-0 .sub-nav").css("visibility", "hidden");
      $(".has-sub-nav-0 .sub-nav").css("opacity", "0");
    });
    $(".has-sub-nav-1 .site-nav__link,.has-sub-nav-1 .sub-nav").mouseover(function () {
      $(".has-sub-nav-1 .site-nav__link").addClass("hover-submenu");
      $(".js__main-header").addClass("active");
      $(".has-sub-nav-1 .sub-nav").css("visibility", "visible");
      $(".has-sub-nav-1 .sub-nav").css("opacity", "1");
    });
    $(".has-sub-nav-1 .site-nav__link,.has-sub-nav-1 .sub-nav").mouseout(function () {
      $(".has-sub-nav-1 .site-nav__link").removeClass("hover-submenu");
      $(".js__main-header").removeClass("active");
      $(".has-sub-nav-1 .sub-nav").css("visibility", "hidden");
      $(".has-sub-nav-1 .sub-nav").css("opacity", "0");
    });
    $(".has-sub-nav-2 .site-nav__link,.has-sub-nav-2 .sub-nav").mouseover(function () {
      $(".has-sub-nav-2 .site-nav__link").addClass("hover-submenu");
      $(".js__main-header").addClass("active");
      $(".has-sub-nav-2 .sub-nav").css("visibility", "visible");
      $(".has-sub-nav-2 .sub-nav").css("opacity", "1");
    });
    $(".has-sub-nav-2 .site-nav__link,.has-sub-nav-2 .sub-nav").mouseout(function () {
      $(".has-sub-nav-2 .site-nav__link").removeClass("hover-submenu");
      $(".js__main-header").removeClass("active");
      $(".has-sub-nav-2 .sub-nav").css("visibility", "hidden");
      $(".has-sub-nav-2 .sub-nav").css("opacity", "0");
    });
    $(".has-sub-nav-3 .site-nav__link,.has-sub-nav-3 .sub-nav").mouseover(function () {
      $(".has-sub-nav-3 .site-nav__link").addClass("hover-submenu");
      $(".js__main-header").addClass("active");
      $(".has-sub-nav-3 .sub-nav").css("visibility", "visible");
      $(".has-sub-nav-3 .sub-nav").css("opacity", "1");
    });
    $(".has-sub-nav-3 .site-nav__link,.has-sub-nav-3 .sub-nav").mouseout(function () {
      $(".has-sub-nav-3 .site-nav__link").removeClass("hover-submenu");
      $(".js__main-header").removeClass("active");
      $(".has-sub-nav-3 .sub-nav").css("visibility", "hidden");
      $(".has-sub-nav-3 .sub-nav").css("opacity", "0");
    });
    $(".has-big-nav .site-nav__link,.has-big-nav .big-nav").mouseover(function () {
      $(".has-big-nav .site-nav__link").addClass("hover-submenu");
      $(".has-big-nav .big-nav").css("visibility", "visible");
      $(".has-big-nav .big-nav").css("opacity", "1");
    });
    $(".has-big-nav .site-nav__link,.has-big-nav .big-nav").mouseout(function () {
      $(".has-big-nav .site-nav__link").removeClass("hover-submenu");
      $(".has-big-nav .big-nav").css("visibility", "hidden");
      $(".has-big-nav .big-nav").css("opacity", "0");
    });
  }
  /*Big menu sub menu click*/


  $(".js__submenu-has-child span").on("click", function () {
    var menuTitle = $(this).attr("data-title");
    $(".big-nav-links").hide();
    $("." + menuTitle).show();
  });
  /* SubMenu
  Accordion JS */

  (function ($) {
    console.log("accordion-toggle1");
    $(function () {
      console.log("accordion-toggle2");
      var navLink = false;
      $(".accordion-toggle").on("mousedown", function (e) {
        "use strict";

        e.stopImmediatePropagation();
        console.log("accordion-toggle");

        if ($(this).parent("div").hasClass("footer-links")) {
          console.log("if footer-links");

          if ($(window).width() < 769) {
            console.log("if 769");

            if ($(this).hasClass("active")) {
              console.log("if active");
              $(this).removeClass("active");
              $(this).siblings(".accordion-content").slideUp(300);
              $(this).siblings(".accordion-content").removeClass("active");
            } else {
              console.log("else active");
              $(".accordion-toggle").removeClass("active");
              $(this).addClass("active");
              $(".accordion-content").slideUp(300);
              $(this).siblings(".accordion-content").slideDown(300);
              $(this).siblings(".accordion-content").addClass("active");
            }
          }
        } else {          
          if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this).siblings(".accordion-content").slideUp(300);
            $(this).siblings(".accordion-content").removeClass("active");
          } else {            
            $(".accordion-toggle").removeClass("active");
            $(this).addClass("active");
            $(".accordion-content").slideUp(300);
            $(this).siblings(".accordion-content").slideDown(300);
            $(this).siblings(".accordion-content").addClass("active");
            $(".js__half-content-half-image-slider-with-tab").slick("refresh");            
          }
        }

        navLink = true;
      }).focus(function (e) {
        "use strict";

        if (navLink) {
          navLink = false;
        } else {
          if ($(this).parent("div").hasClass("footer-links")) {
            console.log("footer-links");

            if ($(window).width() < 769) {
              console.log("accordion-toggle if 769");

              if ($(this).hasClass("active")) {
                console.log("accordion-toggle active if");
                $(this).removeClass("active");
                $(this).siblings(".accordion-content").slideUp(300);
              } else {
                console.log("accordion-toggle active else");
                $(".accordion-toggle").removeClass("active");
                $(this).addClass("active");
                $(".accordion-content").slideUp(300);
                $(this).siblings(".accordion-content").slideDown(300);                
              }
            }
          } else {
            if ($(this).hasClass("active")) {
              $(this).removeClass("active");
              $(this).siblings(".accordion-content").slideUp(300);
            } else {
              $(".accordion-toggle").removeClass("active");
              $(this).addClass("active");
              $(".accordion-content").slideUp(300);
              $(this).siblings(".accordion-content").slideDown(300);                           
            }
          }
        }
      });
    });
  })(jQuery);
  /** HEADER **/

  /** Top Search Result Open Close **/

  /** Top Search Open Close **/


  $(".js__search-popup,.js__close-search-popup").on("click", function () {
    $(".js__header-search").toggleClass("active");
    $(".js__main-header").toggleClass("active");
    $(".js__search-popup").toggleClass("active");
  });
});
/** Fix Header on Scroll **/

$(window).scroll(function () {
  var sticky = $("header"),
      scroll = $(window).scrollTop();

  if (scroll >= 39) {
    sticky.addClass("fixed");
    $(".js__logo").addClass("active");
  } else {
    sticky.removeClass("fixed");

    if ($("#navbarNavDropdown").hasClass("active")) {
      $(".js__logo").addClass("active");
    } else {
      $(".js__logo").removeClass("active");
    }
  }
});
/** Mobile Navigation Open Close **/

(function ($) {
  $(function () {
    var navLink = false;
    $("#hamburger").mousedown(function (e) {
      $(this).toggleClass("active");
      $("#navbarNavDropdown").toggleClass("active");
      $(".js__mobile-menu-open-hide").toggleClass("active");
      $(".js__mobile-announcement-text").toggleClass("active");

      if ($("#navbarNavDropdown").hasClass("active")) {
        $(".js__logo").addClass("active");
      } else {
        $(".js__logo").toggleClass("active");
      }

      navLink = true;
    }).focus(function (e) {
      "use strict";

      if (navLink) {} else {
        $(this).toggleClass("active");
        $("#navbarNavDropdown").toggleClass("active");
        $(".js__mobile-menu-open-hide").toggleClass("active");
        $(".js__mobile-announcement-text").toggleClass("active");

        if ($("#navbarNavDropdown").hasClass("active")) {
          $(".js__logo").addClass("active");
        } else {
          $(".js__logo").toggleClass("active");
        }
      }
    });
  });
})(jQuery);

(function ($) {
  $(function () {
    var navLink = false;
    $("header .has-big-nav .big-nav-link").mousedown(function (e) {
      $(this).toggleClass("active");
      $(".big-nav").toggleClass("active");
      navLink = true;
    }).focus(function (e) {
      "use strict";

      if (navLink) {} else {
        $(this).toggleClass("active");
        $(".big-nav").toggleClass("active");
      }
    });
  });
})(jQuery);

(function ($) {
  $(function () {
    var navLink = false;
    $(".hamburger-close").mousedown(function (e) {
      // $(this).toggleClass("active");
      $("#navbarNavDropdown").toggleClass("active");
      $(".js__overlay").toggleClass("active");
      navLink = true;
    }).focus(function (e) {
      "use strict";

      if (navLink) {} else {
        // $(this).toggleClass("active");
        $("#navbarNavDropdown").toggleClass("active");
        $(".js__overlay").toggleClass("active");
      }
    });
  });
})(jQuery);
/** CART SIDEBAR
 * Close on Outside Click
 * **/


$(document).mouseup(function (e) {
  var popup = $("#CartSidebar");
  var overlay = $("#cart_overlay");

  if (!popup.is(e.target) && popup.has(e.target).length == 0) {
    popup.removeClass("active");
    overlay.removeClass("active");
  }
});
"use strict";

$(document).ready(function ($) {
  $(document).on("mouseenter", ".js__product-cart-color li", function () {
    var productID = $(this).attr("data-product-id");
    var color = $(this).attr("data-color");
    var colorPosition = $(this).parent("ul").attr("color-position");
    var changeImage = "";
    $.each(cartProdLib, function (key, value) {
      if (value["id"] == productID) {
        console.log("productID" + productID);
        $.each(value["variant"], function (key, value) {
          var colorOptionValue = "";

          if (colorPosition == "1") {
            colorOptionValue = value.option1;
          }

          if (colorPosition == "2") {
            colorOptionValue = value.option2;
          }

          if (colorPosition == "3") {
            colorOptionValue = value.option3;
          }

          console.log("colorOptionValue" + colorOptionValue);

          if (color == colorOptionValue) {
            console.log("ifffff1");

            if (changeImage == "") {
              console.log("ifffff2");

              if (value.image.indexOf("no-image-") == -1) {
                console.log("ifffff3");
                changeImage = value.image;
                console.log(changeImage);
              }
            }
          }
        });
        /*Product second image*/

        if (changeImage == "") {
          var count = 1;
          $.each(value["images"], function (key, value) {
            if (count == 2) {
              changeImage = value.image;
            }

            count++;
          });
        }
      }
    });

    if (changeImage != "") {
      $(".js__product-image-" + productID).attr("src", changeImage);
    }
  });
  $(document).on("mouseleave", ".js__product-cart-color li", function () {
    var productID = $(this).attr("data-product-id");
    var featuredImage = $(".js__product-image-" + productID).attr("data-src");
    $(".js__product-image-" + productID).attr("src", featuredImage);
  });
  /*$(document).on("mouseleave", ".boost-pfs-filter-item-swatch li span", function (e) {
      e.preventDefault()
      var image=$(this).parent("li").parent("ul").parent(".boost-pfs-filter-product-bottom-inner").parent(".boost-pfs-filter-product-bottom").parent(".boost-pfs-filter-product-item-inner").children(".image-section").children("a").children("img:first-child").attr("original-image");
      $(this).parent("li").parent("ul").parent(".boost-pfs-filter-product-bottom-inner").parent(".boost-pfs-filter-product-bottom").parent(".boost-pfs-filter-product-item-inner").children(".image-section").children("a").children("img:first-child").attr("src","");
      $(this).parent("li").parent("ul").parent(".boost-pfs-filter-product-bottom-inner").parent(".boost-pfs-filter-product-bottom").parent(".boost-pfs-filter-product-item-inner").children(".image-section").children("a").children("img:first-child").attr("src",image);
      console.log("imagehhh"+$(this).parent("li").parent("ul").parent(".boost-pfs-filter-product-bottom-inner").parent(".boost-pfs-filter-product-bottom").parent(".boost-pfs-filter-product-item-inner").children(".image-section").children("a").children("img:first-child").attr("src"))
  })*/
});
"use strict";

$(document).ready(function ($) {
  var secondOptionVariantValue = "";
  var colorSelected = "";
  var thirdOptionVariantValue = "";
  var successErrorMessageVisible = true;
  var variantOptionArray = {};
  var selectedVariantArray;
  var selectedVariantID;
  var colorSwatchLimit = parseInt(getglobalLib("Color_Swatches_Limit"));
  var colorPosition = $("#colorPosition").val();
  /* Tweak as per requirement - Changes from theme to theme */

  var addToCartAddSpecificPropertyforProduct = false;
  /*Static size*/

  $(".js__static-variant-size li").each(function (index) {
    var size = $(this).children("a").attr("href").toLowerCase().trim();
    console.log("size" + size);
    var url = window.location.href.split('?')[0].toLowerCase().trim();
    console.log("url" + url);

    if (url == size) {
      //console.log("if");
      $(this).children("a").addClass("active");
      $(this).children("a").attr("href", "javascript:;");
      $(".js__static-selected-size").children("p").html($(this).children("a").html());
    }
  });
  $(".js__static-selected-size").children("p").click(function () {
    if ($(window).width() < 481) {
      if ($(".js__static-variant-size").css("display") == "none") {
        $(".js__static-variant-size").slideDown();
      } else {
        $(".js__static-variant-size").slideUp();
      }
    }
  });
  /*Sliders filter when color not exists in variant option*/

  function sliderFilter(OptionValue) {   
    
    if (colorPosition == undefined) {      
      OptionValue = OptionValue.replace(" ", "-");
      OptionValue = OptionValue.replace(/[^a-zA-Z0-9 ]/g, "-");
      OptionValue = OptionValue.replace(/ /g, "-");
      OptionValue = OptionValue.replace(/--/g, "-");
      OptionValue = OptionValue.replace(/---/g, "-");
      $(".pdp-slider").slick("slickUnfilter");
      $(".js__pdp-thumbnail-slider").slick("slickUnfilter");
      $(".pdp-slider").find(".all").addClass(OptionValue.toLowerCase());
      $(".js__pdp-thumbnail-slider").find(".all").addClass(OptionValue.toLowerCase()); //console.log("filtercheck" + thumbColorSelected);

      $(".pdp-slider").slick("slickFilter", "." + OptionValue.toLowerCase());
      $(".pdp-slider").css("opacity", "0"); // 
      //console.log("filtercheck" + thumbColorSelected);

      $(".js__pdp-thumbnail-slider").slick("slickFilter", "." + OptionValue.toLowerCase());
      $(".js__pdp-thumbnail-slider li").removeClass("active");
      $(".js__pdp-thumbnail-slider li:first-child").addClass("active");
      /*Selected first variant image in slider which have no all class*/

      var boolVariantFirstImage = false;
      $(".js__pdp-thumbnail-slider  li").each(function () {
        if (!$(this).hasClass("all")) {
          if (boolVariantFirstImage == false) {
            $(this).click();
            $(this).addClass("active");
            setTimeout(function () {
              $(".pdp-slider").css("opacity", "1");
            }, 300);
            boolVariantFirstImage = true;
          }
        }
      });
      /*When we dont have any variant image*/

      if (boolVariantFirstImage == false) {
        $(".js__pdp-thumbnail-slider li:first-child").addClass("active");
        $(".js__pdp-thumbnail-slider li:first-child").click();
        setTimeout(function () {
          $(".pdp-slider").css("opacity", "1");
        }, 300);
      }
    }
  }
  /*Basic setting */

  /*Varient basic setting dropwon or radio button*/


  if (getglobalLib("Variant_Display") == "dropdown") {
    $(".pdp-size-section").addClass("pdp-option-dropdown-section");
  }
  /*Varient color swatch in on off*/


  if (getglobalLib("Color_Swatches") == "yes") {
    $(".js-variant-color").addClass("swatch-variant-color");
  } else {
    if (getglobalLib("Variant_Display") == "dropdown") {
      $(".pdp-color-section").addClass("pdp-option-dropdown-section");
      $(".pdp-color-section").addClass("js__colorDropdown");
    }
  }
  /*Base setting for slider view all*/


  if (getglobalLib("PDP_Slider_Thumbnail_Viewmore") == "on") {
    $(".js__pdp-thumbnail").addClass("js__pdp-thumbnail-view-more");
  } else {
    $(".js__pdp-thumbnail").addClass("js__pdp-thumbnail-slider");
  }
  /*Slider working Start*/

  /* Main SLIDER  initialization */


  $(".pdp-slider").not(".slick-initialized").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    infinite: false,
    adaptiveHeight: false,
    variableWidth: false,
    responsive: [{
      breakpoint: 769,
      settings: {
        dots: true
      }
    }]
  });

  if (getglobalLib("PDP_Slider_Thumbnail") == "vertical") {
    $(".js__pdp-thumbnail-slider").not(".slick-initialized").slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      dots: false,
      centerMode: false,
      infinite: false,
      focusOnSelect: true,
      variableWidth: false,
      verticalSwiping: true,
      vertical: true,
      arrows: false,
      responsive: [{
        breakpoint: 980,
        settings: {
          verticalSwiping: false,
          vertical: false,
          arrows: false
        }
      }, {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          verticalSwiping: false,
          vertical: false
        }
      }]
    });
  } else {
    $(".js__pdp-thumbnail-slider").not(".slick-initialized").slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      dots: false,
      centerMode: false,
      infinite: false,
      arrows: false,
      focusOnSelect: true,
      variableWidth: false,
      responsive: [{
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }]
    });
  }
  /* Top Write review button click scroll to bottom review section and open write review section*/
  //$(document).on("click", ".js__write-review-btn", function () {


  $(".js__write-review-btn").click(function () {
    /* $(".tab-link").removeClass("active");
     $(".tab-link [data-attr=reviews]").addClass("active");
     $(".write-review-button").click();
     $(".tab-content").removeClass("active");
     $("#reviews").addClass("active");*/
    var target = $(".pdp-review-section");
    setTimeout(function () {
      $("html, body").animate({
        scrollTop: target.offset().top - 200
      }, 500);
    }, 500);
  });
  /*Number click*/

  $(document).on("click", ".js__thumb-number-section", function (e) {
    //console.log(getglobalLib("Image_Popup"));
    if (getglobalLib("Image_Popup") == "yes") {
      //console.log("if main");

      /*If global setting set popup then popup will open otherswise all lis will open*/
      if (getglobalLib("PDP_Thumbnail_Viewmore_Click") == "popup") {
        $("#lightgallery a:nth-child(8) > img").trigger("click"); //console.log("if inner");
      } else {
        //console.log("else inner");
        $(".js__pdp-thumbnail-view-more li").show();
        $(this).hide();
      }
    } else {
      //console.log("else main");

      /*Showing all thumbnail*/
      $(".js__pdp-thumbnail-view-more li").show();
      $(this).hide();
    }
  });
  /*View details*/

  $(document).on("click", ".js__pdp-view-details", function (e) {
    e.preventDefault();
    $(".tab-link").removeClass("active");
    $(".tab-head li:first-child").children(".tab-link").addClass("active");
    $(".tab-content").removeClass("active");
    $(".tab-content:first-child").addClass("active");

    if ($(window).width() < 481) {
      $(".tab-content").children(".inner-content").hide();
      $(".tab-content:first-child").children(".inner-content").show();
    } else {
      $(".tab-content").hide();
      $(".tab-content:first-child").show();
    }

    setTimeout(function () {
      var target = $(".tab-content:first-child");
      $("html, body").animate({
        scrollTop: target.offset().top - 350
      }, 500);
    }, 500);
  });
  /* open light box in small screen from 768px*/

  $(document).on("click", ".js__pdp-slider li", function (e) {
    e.preventDefault();
    var slideno = $(this).index();
    var child = slideno + 1;

    if ($(window).width() < 769) {
      if (getglobalLib("Image_Popup") == "yes") {
        $("#lightgallery a:nth-child(" + child + ") > img").trigger("click");
      }
    }
  });
  /*Pending More Comment*/

  /* Image Popup Visiblity */

  if (getglobalLib("Image_Popup") == "yes") {
    $(".js__pdp-img-popup").removeClass("hide");
    $(".js__pdp-thumbnail").removeClass("mt-45");
  }
  /* Manual click of thumbnail of slider*/


  $(document).on("click", ".pdp-thumbnail li", function (e) {
    if (!$(this).hasClass("js__thumb-number-section")) {
      e.preventDefault();
      var slideno = $(this).index();
      var child = slideno + 1; //console.log("slideno" + slideno);

      $(".pdp-thumbnail li").removeClass("active");
      $(this).addClass("active");
      $(".pdp-slider").slick("slickGoTo", slideno);
      /*Pending More Comment*/

      $(".zoomContainer").remove();

      if ($(window).width() > 768) {
        if (getglobalLib("Image_Zoom") == "yes") {
          $(".pdp-slider li:nth-child(" + child + ")").children(".image-section").children("img").ezPlus({
            zoomType: "inner",
            cursor: "crosshair",
            responsive: "true"
          });
        }
      } else {
        $(".zoomContainer").remove();
      }
    }
  });
  /*Slider working End*/

  /* Call page load functions */

  /*
  setTimeout(function () {
    setColorThumbImages();
  }, 1000);
  */
  
  loopThroughEachCheckedVariantAddToArray();
  /* if no varient then active class added in product image section*/

  if (prodLib.length == 0) {
    $(".js-pdp-media").addClass("active");
    $(".js__pdp-thumbnail-slider li:first-child").addClass("active");
  }
  /*Color Swatch working start*/

  /*
   Choose which color is checked and add class active to that
   Also update the slider thumbs
   */


  colorSelected = $('input[name="typecolor"]:checked').parent("li").attr("data-color-type");
  var colorLoadOption = colorSelected;

  try {
    colorLoadOption = colorLoadOption.replace(/[^a-zA-Z0-9 ]/g, "-");
    colorLoadOption = colorLoadOption.replace(/ /g, "-");
    colorLoadOption = colorLoadOption.replace(/--/g, "-");
    colorLoadOption = colorLoadOption.replace(/---/g, "-");
    $(".js-variant-color li[data-color-type=" + colorLoadOption + "]").addClass("active");
    $(".js-variant-color li[data-color-type=" + colorLoadOption + "]").click();
    $(".js-selected-color").html(colorSelected.replace("-", " "));
  } catch (_unused) {}

  showSelectedColorThumb();
  /*Color drop down open close*/

  $(".js__colorDropdown").children(".selected-color-section").click(function () {
    if ($(".js-variant-color").css("display") == "none") {
      $(".js-variant-color").slideDown();
    } else {
      $(".js-variant-color").slideUp();
    }
  });
  /*Size mobile dd*/

  $(".js__selected-size").children("p").click(function () {
    if ($(window).width() < 481) {
      if ($(".dd-mobile-variant").css("display") == "none") {
        $(".dd-mobile-variant").slideDown();
      } else {
        $(".dd-mobile-variant").slideUp();
      }
    }
  });
  /*Load more click color swatch*/

  if (getglobalLib("Color_Swatches") == "yes") {
    if (getglobalLib("Color_Swatches_ViewAll") == "yes") {
      var x = $("#js-variant-show-more li").length;
      $("#load-more").hide(); //console.log("x" + x);

      $(".js-variant-color li").hide(); //console.log("colorSwatchLimit" + colorSwatchLimit);

      if (x > colorSwatchLimit) {
        $("#load-more").show();
      }

      $("#js-variant-show-more li").slice(0, colorSwatchLimit).show();
    }
  }

  $("#load-more").on("click", function (e) {
    e.preventDefault();
    $("#js-variant-show-more li").show();
    $("#load-more").hide();
  });
  /*PENDING*/

  /* 
  On click of size radio button
  1. Set the Dropdown Value to the selected Size
  2. Update the label value to the selected Size
  3. Loop through the color thumbs to mark from out of stock if the color isn't there for the size selected
  4. After selectio - Slide Up the dropdpown
  */

  /* OUT OF STOCK: Loop through color thumbs to set out of stock message and show quantity message */

  /* OUT OF STOCK: Loop through color thumbs to set out of stock message and show quantity message */

  function loopThroughColorThumbs(colorSelected) {
    //console.log("size" + colorSelected)
    try {
      colorSelected = colorSelected.toLowerCase();
    } catch (_unused2) {}

    var sizeVariantCount = 0;
    $("#ProductSelect-option-1 .variantsRadioSectionOption .variantsRadioOption input").each(function (index) {
      sizeVariantCount++;
    }); //debugger;

    var variantValue;
    $(".js__secondOptionDD").children(".optionSizeRadioOuter").addClass("disabled");
    $(".variantsRadioOptionPrice").html("");
    $(".js-variant-color li").removeClass("out-of-stock");
    $(".js-variant-color li").removeClass("unavailable");
    /*
    Loop Through each input radio for the color
    */

    $("#ProductSelect-option-1 .variantsRadioSectionOption .variantsRadioOption input").each(function (index) {
      var passedElement = this;
      variantValue = $(this).val();
      /* 
       Loop through product library object for variant 
       and if variant select matches and quantity = 0 then show out of stock message
       */
      //var boolVariant=false;

      $(".js-sku-section").hide();
      $(".js__pdp-sku").html("");
      $.each(prodLib, function (key, value) {
        var itemQuantity = value.quantity;
        var itemAvailable = value.available;
        /* COMMENTS REQUIRED
         what happens when quantoty = 0 explain
         */
        //console.log("colorSelected" + colorSelected)
        //console.log("secondOptionVariantValue" + secondOptionVariantValue)

        /*third option checking*/

        if ($("#hiddenpacksize").val() == "true") {
          /*three matching option checking for sku and quantity*/
          if (colorSelected == value.option1.toLowerCase() && secondOptionVariantValue.toLowerCase() == value.option2.toLowerCase() && thirdOptionVariantValue.toLowerCase() == value.option3.toLowerCase()) {
            //console.log("if secondOptionVariantValue" + secondOptionVariantValue)
            if (value.sku != "") {
              $(".js__pdp-sku").html(value.sku);
              $(".js-sku-section").show();
            }
          } else {
            if (secondOptionVariantValue.toLowerCase() == value.option1.toLowerCase() && thirdOptionVariantValue.toLowerCase() == value.option2.toLowerCase()) {
              //console.log("if secondOptionVariantValue" + secondOptionVariantValue)
              if (value.sku != "") {
                $(".js__pdp-sku").html(value.sku);
                $(".js-sku-section").show();
              }
            }
          }
        } else {
          /*two matching option checking for sku and quantity*/
          if (colorSelected == value.option1.toLowerCase() && secondOptionVariantValue.toLowerCase() == value.option2.toLowerCase()) {
            //console.log("if secondOptionVariantValue" + secondOptionVariantValue)
            if (value.sku != "") {
              $(".js__pdp-sku").html(value.sku);
              $(".js-sku-section").show();
            }
          }
        }
        /*Checking each color  size quantity and which have 0 then added out of stock class*/


        if ($("#hiddenpacksize").val() == "true") {
          /*three matching option checking quantity if 0 then showing out of stock */
          if (secondOptionVariantValue.toLowerCase() == value.option2.toLowerCase() && thirdOptionVariantValue.toLowerCase() == value.option3.toLowerCase()) {
            if (itemQuantity < 1 && itemAvailable == "false") {
              var colorOption = value.option1;

              try {
                colorOption = colorOption.replace(/[^a-zA-Z0-9 ]/g, "-");
                colorOption = colorOption.replace(/ /g, "-");
                colorOption = colorOption.replace(/--/g, "-");
                colorOption = colorOption.replace(/---/g, "-");
              } catch (_unused3) {}

              $(".js-variant-color li[data-color-type=" + colorOption + "]").addClass("out-of-stock");
              /*Checking if only one size and color varient out of stock then remove that color*/

              if (sizeVariantCount == 1 && secondOptionVariantValue != "") {
                if ($("#js-variant-show-more li").length < colorSwatchLimit) {
                  if (getglobalLib("Color_Swatches") == "yes") {
                    if (getglobalLib("Color_Swatches_ViewAll") == "yes") {
                      $("#load-more").hide();
                      $(".js-variant-color li").show();
                    }
                  }
                }

                $(".js-variant-color li[data-color-type=" + colorOption + "]").remove();
              }
            }
          }
        } else {
          /*two matching option checking quantity if 0 then showing out of stock */
          if (value.option2.toLowerCase() == secondOptionVariantValue.toLowerCase()) {
            //console.log(itemQuantity);
            //console.log(value.option1);
            //console.log(secondOptionVariantValue);
            if (itemQuantity < 1 && itemAvailable == "false") {
              //console.log("if222");
              var colorOption = value.option1;

              try {
                colorOption = colorOption.replace(/[^a-zA-Z0-9 ]/g, "-");
                colorOption = colorOption.replace(/ /g, "-");
                colorOption = colorOption.replace(/--/g, "-");
                colorOption = colorOption.replace(/---/g, "-");
              } catch (_unused4) {}

              $(".js-variant-color li[data-color-type=" + colorOption + "]").addClass("out-of-stock");
              /*Checking if only one size and color varient out of stock then remove that color*/

              if (sizeVariantCount == 1 && secondOptionVariantValue != "") {
                if (getglobalLib("Color_Swatches") == "yes") {
                  if (getglobalLib("Color_Swatches_ViewAll") == "yes") {
                    //console.log("if333");
                    if ($("#js-variant-show-more li").length < colorSwatchLimit) {
                      $("#load-more").hide();
                      $(".js-variant-color li").show();
                    }
                  }
                }

                $(".js-variant-color li[data-color-type=" + colorOption + "]").remove();
              }
            }
          }
        }
      });
    });
    /*Checking Unavailable and then adding out of stock */

    var colorLength = $(".js-variant-color li").length;
    var colorCount = 1;
    $(".js-variant-color li").each(function (index) {
      var color = $(this).attr("data-color");
      var boolVariant = false; //console.log("color22" + color)
      //console.log("size22" + secondOptionVariantValue)

      $.each(prodLib, function (key, value) {
        if (value.option1 == color) {
          if ($("#hiddenpacksize").val() == "true") {
            if (value.option2.toLowerCase() == secondOptionVariantValue.toLowerCase() && value.option3.toLowerCase() == thirdOptionVariantValue.toLowerCase()) {
              boolVariant = true;
            }
          } else {
            //console.log("dddddd else")
            if (value.option2.toLowerCase() == secondOptionVariantValue.toLowerCase()) {
              //console.log(value.option2+"size matched" +secondOptionVariantValue);
              //console.log("avlaible"+color)
              boolVariant = true;
            }
          }
        }
      }); //console.log(boolVariant)

      if (boolVariant == false) {
        var colorOption = color;

        try {
          colorOption = colorOption.replace(/[^a-zA-Z0-9 ]/g, "-");
          colorOption = colorOption.replace(/ /g, "-");
          colorOption = colorOption.replace(/--/g, "-");
          colorOption = colorOption.replace(/---/g, "-");
        } catch (_unused5) {} //console.log("colorOption unavailable"+colorOption);


        $(".js-variant-color li[data-color-type=" + colorOption + "]").addClass("out-of-stock");
        $(".js-variant-color li[data-color-type=" + colorOption + "]").addClass("unavailable");

        if ($(".js-variant-color li[data-color-type=" + colorOption + "]").hasClass("active")) {
          var nextColor = colorCount + 1;

          if (colorCount < colorLength) {
            $(".js-variant-color li:nth-child(" + nextColor + ")").click();
          } else {
            $(".js-variant-color li:nth-child(1)").click();
          }
        }
        /*Checking if only one size and color varient out of stock then remove that color*/


        if (sizeVariantCount == 1 && secondOptionVariantValue != "") {
          //  alert($(".js-variant-color li").length)
          if (getglobalLib("Color_Swatches") == "yes") {
            if (getglobalLib("Color_Swatches_ViewAll") == "yes") {
              if ($("#js-variant-show-more li").length < colorSwatchLimit) {
                $("#load-more").hide();
                $(".js-variant-color li").show();
              }
            }
          }

          $(".js-variant-color li[data-color-type=" + colorOption + "]").remove();
        }
      }

      colorCount++;
    });
    var colorSwatchCount = 0;
    $(".js-variant-color li").each(function (index) {
      if (!$(this).hasClass("unavailable")) {
        colorSwatchCount++;
      }
    });

    if (getglobalLib("Color_Swatches") == "yes") {
      if (getglobalLib("Color_Swatches_ViewAll") == "yes") {
        if (colorSwatchCount < colorSwatchLimit) {
          $("#load-more").hide();
          $(".js-variant-color li").show();
        } else {
          $(".js-variant-color li").hide();
          $("#load-more").show();
          $("#js-variant-show-more li").slice(0, colorSwatchLimit).show();
        }
      }
    }
    /*Second option Out of stock or unavlaible*/
    //colorSelected
    //console.log("secondOptionVariantValue" + secondOptionVariantValue);
    //console.log("thirdOptionVariantValue" + thirdOptionVariantValue);
    //console.log("colorSelected" +colorSelected)


    $(".js__secondOptionDD_Outer .variantsRadioOption").children("label").removeClass("out-of-stock");
    $(".js__thirdOptionDD_Outer .variantsRadioOption").children("label").removeClass("out-of-stock");
    $.each(prodLib, function (key, value) {
      var itemQuantity = value.quantity;
      var itemAvailable = value.available;
      var colorOption = value.option1.toLowerCase();
      colorOption = colorOption.replace(/[^a-zA-Z0-9 ]/g, "-");
      colorOption = colorOption.replace(/ /g, "-");
      colorOption = colorOption.replace(/--/g, "-");
      colorOption = colorOption.replace(/---/g, "-");
      var selectedColor = colorSelected;

      try {
        selectedColor = selectedColor.replace(/[^a-zA-Z0-9 ]/g, "-");
        selectedColor = selectedColor.replace(/ /g, "-");
        selectedColor = selectedColor.replace(/--/g, "-");
        selectedColor = selectedColor.replace(/---/g, "-");
      } catch (_unused6) {}

      var option2 = value.option2.toLowerCase();
      var option3 = value.option3.toLowerCase(); //console.log("option3" +option3)
      //console.log("option2" +option2)
      //console.log("colorOption" +colorOption)

      /*Three option */

      if ($("#hiddenpacksize").val() == "true") {
        //console.log("three options")

        /*Color and second option matching */
        if (colorOption == selectedColor.toLowerCase() && secondOptionVariantValue.toLowerCase() == option2) {
          //console.log("three options if 1")
          if (itemQuantity < 1 && itemAvailable == "false") {
            $(".js__thirdOptionDD_Outer .variantsRadioOption").each(function () {
              if ($(this).children(".js-optionRadio").val() == value.option3) {
                $(this).children("label").addClass("out-of-stock");
              }
            });
          }
        }
        /*Color and Third option matching */


        if (colorOption == selectedColor.toLowerCase() && thirdOptionVariantValue.toLowerCase() == option3) {
          //console.log("three options if 2")
          if (itemQuantity < 1 && itemAvailable == "false") {
            $(".js__secondOptionDD_Outer .variantsRadioOption").each(function () {
              if ($(this).children(".js-optionRadio").val() == value.option2) {
                $(this).children("label").addClass("out-of-stock");
              }
            });
          }
        }
      } else {
        /*two option */
        if (colorOption == selectedColor) {
          if (itemQuantity < 1 && itemAvailable == "false") {
            var option2 = value.option2; //console.log("option2" + option2)

            $(".js__secondOptionDD_Outer .variantsRadioOption").each(function () {
              //console.log("Radio-option2" + $(this).children(".js-optionRadio").val())
              if ($(this).children(".js-optionRadio").val() == option2) {
                $(this).children("label").addClass("out-of-stock");
              }
            });
          }
        }
      }
    });
  }
  /******
    COLOR THUMB CLICK
    ******/


  $(".js-variant-color li").click(function () {
    //remove the active class from any color li
    $(".js-variant-color li").removeClass("active"); // add the active class

    $(this).addClass("active"); //set the color selected

    colorSelected = $(this).attr("data-color");
    /*Local storage for color*/

    localStorage.setItem("selectedColor", colorSelected);
    /* On click of colors loop through all color thumbs to set out of stock working + show quantity message */
    
    loopThroughColorThumbs(colorSelected);
    /*
    fire the radio button click and add checked
    Need to replace - with space as the variants have space in between in actual radio button
    */
    //set the color selected to the label

    $(".js-selected-color").html(colorSelected.replace("-", " "));
    /*Slider and thumbnail filter*/

    showSelectedColorThumb(colorSelected);
    $("input[name=color][value='" + colorSelected + "']").click();
    $("input[name=color][value='" + colorSelected + "']").prop("checked", true);
    $("input[name=typecolor][colorValue='" + colorSelected + "']").prop("checked", true);

    if (getglobalLib("Variant_Display") == "dropdown") {
      /*Varient color swatch in on off*/
      if (getglobalLib("Color_Swatches") != "yes") {
        $(".js-variant-color").slideUp();
      }
    }
  });
  /*Pending*/

  /* For selected color setting slider thumb and main slider reset*/

  function showSelectedColorThumb() {
    
    try {
      var ImageColorToLowerCase = colorSelected.toLowerCase();
    } catch (_unused7) {}

    var colorSize = ImageColorToLowerCase;
        
    if (secondOptionVariantValue != "") {
      colorSize = ImageColorToLowerCase + "~" + secondOptionVariantValue.toLowerCase();
    }

    if (colorSelected != "" && colorSelected != undefined) {
      try {
        
        var $imageSlider = $(".pdp-slider");
        var $thumbSlider = $(".js__pdp-thumbnail-slider");        
        
        $(".js-pdp-media").addClass("active");
        var thumbColorSelected = colorSelected.replace(" ", "-");
        thumbColorSelected = thumbColorSelected.replace(/[^a-zA-Z0-9 ]/g, "-");
        thumbColorSelected = thumbColorSelected.replace(/ /g, "-");
        thumbColorSelected = thumbColorSelected.replace(/--/g, "-");
        thumbColorSelected = thumbColorSelected.replace(/---/g, "-"); 
        thumbColorSelected = thumbColorSelected.toLowerCase();

        $imageSlider.css("opacity", "0");
        $thumbSlider.css("opacity", "0");
        
        $imageSlider.slick("slickUnfilter");
        $thumbSlider.slick("slickUnfilter");        
        
        var colorThumb = $thumbSlider.find('.' + thumbColorSelected).not('.all');               
        var colorImage = $imageSlider.find('.' + thumbColorSelected).not('.all');                       
        
        if( colorThumb && colorImage ) {               
          $thumbSlider.slick('slickAdd', colorThumb, 0, true);
          $imageSlider.slick('slickAdd', colorImage, 0, true);
        }        
        
        $imageSlider.find(".all").addClass(thumbColorSelected);
        $thumbSlider.find(".all").addClass(thumbColorSelected); 

        $imageSlider.slick("slickFilter", "." + thumbColorSelected);  
        $thumbSlider.slick("slickFilter", "." + thumbColorSelected);        
                
        $thumbSlider.find("li:first-child").click()
        
        
        $imageSlider.css("opacity", "1");
        $thumbSlider.css("opacity", "1");
        

        if ($(window).width() > 768) {
          if (getglobalLib("Image_Zoom") == "yes") {
            $(".pdp-slider li:first-child").children(".image-section").children("img").ezPlus({
              zoomType: "inner",
              cursor: "crosshair",
              responsive: "true"
            });
          }
        } else {
          $(".zoomContainer").remove();
        }
      } catch (_unused8) {}

      var thumbExtraCount = 0;
      var thumbCount = 1;
      $(".js__pdp-thumbnail-view-more").empty();
      $("#lightgallery").empty();
      var productTitle = $(".js__pdp-title").html();
      /*Product thumb checking with dd selected and thumb and slider image reset*/

      $(".js-productDetailThumbImages-hidden  li").each(function () {
        try {
          var imgAlt = $(this).children(".image-section").children("img").attr("alt").toLowerCase().split(" / ")[1].split("-")[1];

          if (imgAlt == ImageColorToLowerCase) {
            var img = $(this).children(".image-section").children("img").attr("src");
            $("#lightgallery").append("<a href=" + img + ' title="' + productTitle + '" >' + productTitle + "<img src=" + img + " alt=" + imgAlt + "> </a>");

            if (thumbCount == 1) {
              $(".js__pdp-thumbnail-view-more").append('<li class="active"><div class="image-section"><img src="' + img + '" alt="' + imgAlt + '"></div></li>');
            } else {
              if (thumbCount > 7) {
                $(".js__pdp-thumbnail-view-more").append('<li style="display:none"><div class="image-section"><img src="' + img + '" alt="' + imgAlt + '"></div></li>');
              } else {
                $(".js__pdp-thumbnail-view-more").append('<li><div class="image-section"><img src="' + img + '" alt="' + imgAlt + '"></div></li>');
              }
            }

            thumbCount++;
          }
        } catch (_unused9) {}
      });

      if (thumbCount > 7) {
        thumbExtraCount = thumbCount - 8;
        $(".js__pdp-thumbnail-view-more").append('<li class="js__thumb-number-section"><div class="number-section">+' + thumbExtraCount + "</div></li>");
      }

      lightGallery(document.getElementById("lightgallery"), {
        thumbnail: true,
        thumbWidth: 70,
        thumbContHeight: 70,
        toggleThumb: false
      });
    } else {
      $(".js-pdp-media").addClass("active");
      $(".js__pdp-thumbnail-slider li:first-child").addClass("active");
    }
  }
  /*Color Swatch workign end*/

  /*Radio dd working start*/

  /* Loop through each Size options and show the selected size */


  $(".optionSizeRadioOuter").each(function () {
    if ($(this).children(".variantsRadioOption").is(":checked")) {
      secondOptionVariantValue = $(this).children(".optionSizeRadio").children(".js-variantsRadioOptionValue").html();
      $(".js__secondOptionDD_Outer").find("p").html(secondOptionVariantValue);
      /*Color thumbs, out of stock and unavailable */

      setTimeout(function () {
        loopThroughColorThumbs(colorSelected);
        sliderFilter(secondOptionVariantValue);
      }, 1000);

      if (getglobalLib("Variant_Display") == "dropdown") {
        $(".js__secondOptionDD").slideUp();
      }

      secondOptionVariantValue = secondOptionVariantValue.toLowerCase();
    }
  });
  /*PENDING Class and variable name is wrong */

  /*Variant radio button click */

  $(".js__secondOptionDD input[type=radio]").click(function () {
    //Set selected value
    secondOptionVariantValue = $(this).parent("div").children("label").children(".js-variantsRadioOptionValue").html();

    try {
      //add checked attribute
      $(".variantsRadioOption [value=" + secondOptionVariantValue + "]").attr("checked", "checked");
    } catch (_unused10) {} //Show selected value in a label


    $(".js__secondOptionDD_Outer").find("p").html(secondOptionVariantValue);
    /*Color thumbs, out of stock and unavailable */

    loopThroughColorThumbs(colorSelected);
    /*Formatting: Custom DD design */

    if (getglobalLib("Variant_Display") == "dropdown") {
      $(".js__secondOptionDD").slideUp();
    }

    if ($(window).width() < 481) {
      $(".js__secondOptionDD").slideUp();
    }

    secondOptionVariantValue = secondOptionVariantValue.toLowerCase();
    sliderFilter(secondOptionVariantValue);
  });
  /*PENDING Class and variable name is wrong 
  merge top and bottom code
  */

  $(".js__thirdOptionDD input[type=radio]").click(function () {
    thirdOptionVariantValue = $(this).parent("div").children("label").children(".js-variantsRadioOptionValue").html();

    try {
      $(".variantsRadioOption [value=" + thirdOptionVariantValue + "]").attr("checked", "checked");
    } catch (_unused11) {}

    $(".js__thirdOptionDD_Outer").find("p").html(thirdOptionVariantValue.toLowerCase());
    loopThroughColorThumbs(colorSelected);

    if (getglobalLib("Variant_Display") == "dropdown") {
      $(".js__thirdOptionDD").slideUp();
    }

    if ($(window).width() < 481) {
      $(".js__thirdOptionDD").slideUp();
    }

    thirdOptionVariantValue = thirdOptionVariantValue.toLowerCase();
    sliderFilter(thirdOptionVariantValue);
  });
  /*PENDING Class and variable name is wrong */

  /*PAGE LOAD: Loop through each Pack Size options and show the selected size */

  $(".optionPackSizeRadioOuter").each(function () {
    //console.log("thirdOptionVariantValue");
    if ($(this).children(".variantsRadioOption").is(":checked")) {
      thirdOptionVariantValue = $(this).children(".optionPackSizeRadio").children(".js-variantsRadioOptionValue").html().toLowerCase(); //console.log(thirdOptionVariantValue);

      $(".js__thirdOptionDD_Outer").find("p").html(thirdOptionVariantValue);
      setTimeout(function () {
        loopThroughColorThumbs(colorSelected);
        sliderFilter(secondOptionVariantValue);
      }, 1000);
    }
  });
  /*PENDING Class and variable name is wrong */

  /* FORMATTING: Custom On click of size DropDown - open the list and hide the color selection dropdown open list*/

  $(".js__secondOptionDD_Outer p").click(function () {
    if (getglobalLib("Variant_Display") == "dropdown") {
      if ($(".js__secondOptionDD").css("display") == "none") {
        $(".js__secondOptionDD").slideDown();
        $(".js__thirdOptionDD").hide();
      } else {
        $(".js__secondOptionDD").slideUp();
      }
    }
  });
  /*PENDING Class and variable name is wrong */

  /* FORMATTING: Custom On click of pack size DropDown - open the list and hide the color selection dropdown open list*/

  $(".js__thirdOptionDD_Outer p").click(function () {
    if ($(".js__thirdOptionDD").css("display") == "none") {
      $(".js__thirdOptionDD").slideDown();
      $(".js__secondOptionDD").hide();
    } else {
      $(".js__thirdOptionDD").slideUp();
    }
  });
  /*Radio dd working end*/

  /*
   PDP: Radio Button Click
   */

  /* ON PAGE LOAD
    Get the value of the checked radio button for all the types
   get the name and value e.g. name = color, value = red */

  function loopThroughEachCheckedVariantAddToArray() {
    $(".js-fieldset-variant .variantsRadioSectionOption .variantsRadioOption input:checked").each(function (index) {
      var variantKey = $(this).attr("name");
      var variantValue = $(this).val();
      /* Adding a map of name to value */

      variantOptionArray[variantKey] = variantValue;
      variantSelection(this); //console.log(variantOptionArray);
    });
  }
  /*******
  RADIO BUTTON CLICK 
   *******/


  $(".product-actions-wrapper .js-optionRadio").click(function (e) {
    //debugger;
    //console.log("------------------------- BEGIN------------------");
    variantSelection(this);
  });

  function variantSelection(passedElement) {
    // debugger;
    // $(".js-add-to-cart-btn").prop("disabled", true);

    /*
    Get the clicked radio button  name and value
    */
    var variantValue = $(passedElement).parent(".variantsRadioOption").children("input").val();
    var variantKey = $(passedElement).parent(".variantsRadioOption").children("input").attr("name");
    /* Check if the key exists in the array or not 
    if it exists, then update the key with the new value
    e.g. on load color = red
    but on click  - color = blue
    */

    if (variantKey in variantOptionArray) {
      //console.log("TRUEEEEEEE KEY EXISTS IN THE ARRAY");
      //console.log(variantKey);
      variantOptionArray[variantKey] = variantValue; // if key exists, then don't do anything
    } //console.log(variantOptionArray);

    /* Set the variant ID */


    loopThroughProductLiquidVariable();
    var count = 1;
    /* go through each select options */

    $(".selector-wrapper").each(function (index) {
      //console.log("count" + count);
      var checkSelectLabelVal = $(this).children("label").text().toLowerCase(); //console.log("CHECKSelectLabelVal" + checkSelectLabelVal);
      //console.log("variantKey" + variantKey);
      //console.log("variantValue" + variantValue);

      if (checkSelectLabelVal.replace(/ /g, "-").trim() == variantKey) {
        ////console.log($(this).children("label").text().toLowerCase());

        /*fire the select change for that option and set it's value */
        //console.log("ifvariantValue" + variantValue);
        $(this).children("select").val(variantValue);
        $(this).children("select").change();
      }

      count++;
    });
  }
  /* */


  function loopThroughProductLiquidVariable() {
    selectedVariantArray = Object.keys(variantOptionArray);
    /* get the variant ID */

    if (typeof prodLib !== "undefined") {
      $.each(prodLib, function (key, value) {
        if (selectedVariantArray.length == 1 && variantOptionArray[selectedVariantArray[0]] == value.option1) {
          selectedVariantID = value.id;
          $(".js-add-to-cart-btn").removeClass("hide");
        }

        if (selectedVariantArray.length == 2 && variantOptionArray[selectedVariantArray[0]] == value.option1 && variantOptionArray[selectedVariantArray[1]] == value.option2) {
          selectedVariantID = value.id;
          $(".js-add-to-cart-btn").removeClass("hide");
        }

        if (selectedVariantArray.length == 3 && variantOptionArray[selectedVariantArray[0]] == value.option1 && variantOptionArray[selectedVariantArray[1]] == value.option2 && variantOptionArray[selectedVariantArray[2]] == value.option3) {
          //  //console.log("case 3");
          //  //console.log(value.id);
          //console.log("price: " + value.price);
          //console.log("compared price: " + value.priceCompared);
          selectedVariantID = value.id;
          $(".js-add-to-cart-btn").removeClass("hide");
        }
      });
    }
  }
  /* Add to cart working */


  $(".js-add-to-cart-btn, #AddToCart").click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    
    if (prodLib.length == 0) {
      selectedVariantID = $(this).attr("data-attr-itemid"); ////console.log("selectedVariantID: when NULL: " + selectedVariantID);
    } else {}

    selectedVariantID = parseInt(selectedVariantID); //console.log("selectedVariantID:: " + selectedVariantID);
    
    var submitCartText = $(this).html().toLowerCase();    

    if (submitCartText.includes("add to cart")) {
      var cartSuccess = false;
      var quantity = parseInt($(".js-quantity-selector").val());      
      var sellingPlanID = $(this).attr('data-selling-plan-id');
      var items = [];
      /* CUSTOM: Properties */

      if (addToCartAddSpecificPropertyforProduct && (selectedVariantID == "39627553964102" || selectedVariantID == "39627553996870" || selectedVariantID == "39627554029638" || selectedVariantID == "39627554062406")) {
        items.push({
          id: selectedVariantID,
          quantity: quantity,
          properties: {
            _promoOffer: "true"
          }
        });
      } else {
        /* For the main item */
        items.push({
          id: selectedVariantID,
          quantity: quantity,
          selling_plan: sellingPlanID
        });
      }

      CartJS.addItems(items, {
        success: function success(response, textStatus, jqXHR) {
          CartJS.getNote(); //console.log(response);
          //console.log(CartJS.cart);

          cartSuccess = true;

          if (getglobalLib("Mini_Cart") == "yes") {
            /* Show message */
            showCartSuccessMessage();
          } else {
            window.location = "/cart";
          }
        },
        // Define an error callback to display an error message.
        error: function error(jqXHR, textStatus, errorThrown) {
          showCartErrorMessage();
        }
      });
    } // Fire click for the Klaviyo - Back in stock
    else {
        if (submitCartText = "Notify me when back in stock") {
          document.querySelector('.klaviyo-bis-trigger').click(); //$(".klaviyo-bis-trigger").click()
        }
      }
  });
  /*PENDING Merge
   */

  /*Quantity Plus Minus*/

  $(".js-product-single__quantity .js-minus-qty").click(function () {
    var productQuantity = $(".js-quantity-selector").val();

    if (productQuantity > 1) {
      productQuantity--;
    }

    $(".js-quantity-selector").val(productQuantity);
  });
  $(".js-product-single__quantity .js-plus-qty").click(function () {
    var productQuantity = $(".js-quantity-selector").val();
    productQuantity++;
    $(".js-quantity-selector").val(productQuantity);
  });
  /* PENDING*/

  $(".js__accordian-tab-pdp").click(function (e) {
    e.preventDefault();

    if ($(this).parent(".tab-content").children(".inner-content").css("display") == "none") {
      $(".js__tab li").removeClass("active");
      $(".tab-content").removeClass("active");
      $(".tab-content").children(".inner-content").slideUp();
      $(this).parent(".tab-content").children(".inner-content").slideDown();
      $(this).parent(".tab-content").addClass("active");
      var target = $(this).parent(".tab-content").children(".inner-content");
      setTimeout(function () {
        $("html, body").animate({
          scrollTop: target.offset().top - 200
        }, 1000);
      }, 500);
    } else {
      $(this).parent(".tab-content").children(".inner-content").slideUp();
      $(this).parent(".tab-content").removeClass("active");
    }
  });
});
/*PENDING Get Variant Color*/

function getVariantColor(color) {
  //console.log("function called");
  try {
    var variantColorValue = "";
    $.each(prodColor, function (key, value) {
      if (color.toLowerCase() == value.title.toLowerCase()) {
        variantColorValue = value.color;
      }
    });
    /* $.each(prodLib, function (key, value) {
       if (color.toLowerCase() == value.option1.toLowerCase()) {
         variantColorValue = value.image;
       }
     });*/
    //console.log("CHECK - variantColorValue: " +  variantColorValue);

    return variantColorValue;
  } catch (_unused12) {}
}

$(document).ready(function ($) {
  /*Local storage*/
  setTimeout(function () {
    //console.log("localStorage"+localStorage.getItem('selectedColor'))
    if (localStorage.getItem('selectedColor') != null) {
      if (localStorage.getItem('selectedColor') != "") {
        $(".js-variant-color li").each(function (index) {
          var color = $(this).attr("data-color");

          if (localStorage.getItem('selectedColor') == color) {
            $(this).children("input").attr("checked", "checked");
            $(this).click();
          }
        });
      }
    }
  }, 500);
});
/* FORMATTING: Loop Through each color thumb and set the images for them through the product color library object */

/*
function setColorThumbImages() {
  if ($(".js-variant-color-swatch li")[0]) {
    $(".js-variant-color-swatch  li").each(function (index) {
      var color = $(this).attr("data-color");
      var colorValue = getVariantColor(color); //$(this).children("div.color").css("background-color", colorValue);

      if (colorValue == "") {
        $(this).children("img").css("opacity", "0");
      }

      $(this).children("img").attr("src", colorValue);
    });
  }
}
*/